export default {
  common: {
    save: 'پاشکەوتکردن',
    cancel: 'هەڵوەشاندنەوە',
    ok: 'باشە',
    copied: 'کۆپیکرا',
    selectAllLabel: 'هەموو هەڵبژێرە',
    submit: 'ناردن',
    logout: 'چوونە دەرەوە',
    skip: 'پەڕاندن',
    viewMore: 'زیاتر ببینە',
    viewLess: 'کەمتر ببینە',
    changeLanguage: 'گۆڕینی زمان',
    areYouSure: 'دڵنیایت؟',
    done: 'ئەنجامدرا',
    error: 'هەڵە',
    close: 'داخستن',
    noResultsFound: 'هیچ ئەنجامێک نەدۆزرایەوە',
    typeToSearch: 'تکایە شتێک بنووسە بۆ گەڕان!',
    typeToSearchPlaceholder: 'بنووسە بۆ گەڕان',
    active: 'چالاک',
    edit: 'دەستکاریکردن',
    updatedSuccessfully: 'بە سەرکەوتوویی نوێکرایەوە',
    success: 'سەرکەوتوو',
    addedSuccessfully: 'بە سەرکەوتوویی زیادکرا',
    date: 'بەروار',
    user: 'بەکارهێنەر',
    new: 'نوێ',
    delete: 'سڕینەوە',
    cash: 'نەقد',
    deletedSuccessfully: 'بە سەرکەوتوویی سڕایەوە',
    back: 'گەڕانەوە',
    inactive: 'ناچالاک',
    all: 'هەموو',
    add: 'زیادکردن',
    create: 'دروستکردن',
    update: 'نوێکردنەوە',
    reset: 'دووبارە دانانەوە',
    editQuestion: 'دەستکاری؟',
    search: 'گەڕان',
    select: 'هەڵبژێرە',
    filterColon: 'پاڵاوتن:',
    showResultLabel: 'پیشاندان',
    resultLabel: 'ئەنجام',
    totalResultLabel: 'کۆی ئەنجامەکان {count}',
    selectedCountLabel: '{count} هەڵبژێردرا',
    of: 'لە',
    canceledStatus: 'هەڵوەشێنراوە',
    refundedStatus: 'گەڕێندراوەتەوە',
    mobileSource: 'مۆبایل',
    webSource: 'ماڵپەڕ',
    adminSource: 'بەڕێوەبەری',
    warning: 'ئاگاداری',
    yes: 'بەڵێ',
    no: 'نەخێر',
    example: 'نموونە: {value}'
  },
  columns: {
    id: 'ناسنامە',
    item: 'کاڵا',
    itemCode: 'کۆدی داواکاری',
    customer: 'کڕیار',
    name: 'ناو',
    email: 'ئیمەیل',
    phoneNumber: 'ژمارەی مۆبایل',
    itemName: 'ناوی بەرهەم',
    brand: 'براند',
    url: 'لینک',
    image: 'وێنە',
    dateTime: 'بەروار و کات',
    status: 'دۆخ',
    statuses: 'دۆخەکان',
    checkBoxColumn: 'بۆکسی هەڵبژاردن',
    warehouse: 'کۆگا',
    branch: 'لق',
    role: 'ڕۆڵ',
    summary: 'کورتەیی',
    shipping: 'گەیاندن',
    total: 'کۆی گشتی',
    qty: 'ژمارە',
    size: 'قەبارە',
    price: 'نرخ',
    logo: 'لۆگۆ',
    defaultImage: 'وێنەی بنەڕەت',
    country: 'وڵات',
    currency: 'دراو',
    prefix: 'پێشگر',
    transportationTypes: 'جۆرەکانی گواستنەوە',
    city: 'شار',
    street: 'شەقام',
    code: 'کۆد',
    houseNumber: 'ژمارەی ماڵ',
    estimateDays: 'ڕۆژی خەمڵێنراو',
    actions: 'کردارەکان',
    stateProvince: 'ویلایەت - پارێزگا',
    flagCode: 'کۆدی ئاڵا',
    customCode: 'کۆدی تایبەت',
    qr: 'QR',
    customerId: 'ژمارەی کڕیار',
    phone: 'مۆبایل',
    headQuarter: 'ناوەندی سەرەکی',
    type: 'جۆر',
    purchaseNote: 'تێبینی کڕین',
    bank: 'بانک',
    invoiceNo: 'ژمارەی وەسڵ',
    orderId: 'ژمارەی داواکاری',
    productName: 'ناوی بەرهەم',
    quantity: 'بڕ',
    note: 'تێبینی',
    qrId: 'ژمارەی QR',
    payment: 'پارەدان',
    orderInfo: 'زانیاری داواکاری',
    itemDetails: 'وردەکاری بەرهەم',
    product: 'بەرهەم',
    statusLocation: 'دۆخ و شوێن',
    pricing: 'نرخنان',
    datePayment: 'بەروار و پارەدان',
    invoiceInfo: 'زانیاری پسوولە',
    shipmentCosts: 'تێچووی گەیاندن',
    cleared: 'ڕێکخرا',
    purchaseDate: 'بەرواری کڕین',
    warehouseDate: 'بەرواری کۆگا',
    bankName: 'ناوی بانک',
    actualCost: 'تێچووی ڕاستەقینە',
    purchaseCost: 'تێچووی کڕین',
    totalAmount: 'کۆی بڕی پارە',
    purchasedBy: 'کڕدرا لەلایەن',
    refundNumber: 'ژمارەی گەڕاندنەوە',
    refundNote: 'تێبینی گەڕاندنەوە',
    discount: 'داشکاندن',
    weight: 'کێش',
    deliveryPrice: 'نرخی گەیاندن',
    nationalTax: 'باجی نیشتیمانی',
    totalRefunded: 'کۆی گەڕێندراوە',
    refundStatus: 'دۆخی گەڕاندنەوە',
    trackNumber: 'ژمارەی شوێنپێدان',
    orderNumber: 'ژمارەی داواکاری',
    createDate: 'بەرواری دروستکردن',
    caseId: 'ژمارەی کەیس',
    caseOrderId: 'ژمارەی داواکاری',
    createdBy: 'دروستکراوە لەلایەن',
    customerPhone: 'مۆبایلی کڕیار',
    sentBy: 'نێردراوە لەلایەن',
    deadline: 'کۆتا ماوە',
    attachedInvoices: 'وەسڵە پەیوەستکراوەکان',
    customerPhone2: 'مۆبایلی کڕیار ٢',
    defaultLocation: 'شوێنی بنەڕەت',
    totalPrice: 'نرخی گشتی',
    orderHash: 'ژمارەی داواکاری #',
    volume: 'قەبارە',
    handlingFee: 'کرێی جێبەجێکردن',
    shipment: 'گەیاندن',
    tax: 'باج',
    amount: 'بڕی پارە',
    paidAmount: 'بڕی پارەدراو',
    remaining: 'ماوە',
    outOffice: 'دەرەوەی نووسینگە',
    owner: 'خاوەن',
    receivedDate: 'بەرواری وەرگرتن',
    receivedAmount: 'بڕی وەرگیراو',
    createdAt: 'بەرواری دروستکردن',
    updatedAt: 'بەرواری نوێکردنەوە',
    checkBox: 'بۆکسی هەڵبژاردن',
    deliveryAddress: 'ناونیشانی گەیاندن',
    generatedBy: 'دروستکراوە لەلایەن',
    dateFilterByLabel: 'پاڵاوتنی ڕێکەوت بەپێی',
    selectedSuffix: 'هەڵبژێردراو',
    orderStatus: 'دۆخی داواکاری',
    productUrl: 'لینکی بەرهەم',
    transactionDate: 'بەرواری مامەڵە',
    staffName: 'ناوی ستاف',
    action: 'کردار',
    exRate: 'نرخی ئاڵوگۆڕ',
    paymentMethod: 'شێوازی پارەدان',
    logDate: 'بەرواری تۆمار',
    cid: 'ژمارەی کڕیار',
    subscription: 'بەشداریکردن',
    rateLog: 'تۆماری نرخ',
    paidVia: 'پارەدان لە ڕێگەی',
    title: 'ناونیشان',
    order: 'ڕیزبەندی',
    question: 'پرسیار',
    answer: 'وەڵام',
    coupon: 'کۆپۆن',
    expireDate: 'بەرواری بەسەرچوون',
    percentage: 'ڕێژە سەدی',
    nameArabic: 'ناو (عەرەبی)',
    nameKurdish: 'ناو (کوردی)',
    reasonEnglish: 'هۆکار (ئینگلیزی)',
    reasonArabic: 'هۆکار (عەرەبی)',
    reasonKurdish: 'هۆکار (کوردی)',
    shipzoneFee: 'کرێی شیپ زۆن',
    handlingFeeAir: 'کرێی جێبەجێکردن (ئاسمانی)',
    handlingFeeSea: 'کرێی جێبەجێکردن (دەریایی)',
    itemPriceAir: 'نرخی کاڵا (ئاسمانی)',
    itemPriceSea: 'نرخی کاڵا (دەریایی)',
    itemPriceLand: 'نرخی کاڵا (وشکانی)',
    localDelivery: 'گەیاندنی ناوخۆیی',
    default: 'بنەڕەتی',
    netPrice: 'نرخی پاک',
    transportationType: 'جۆری گواستنەوە',
    ordersStatus: 'دۆخی داواکارییەکان',
    postalCode: 'کۆدی پۆستە',
    customerName: 'ناوی کڕیار',
    customerNote: 'تێبینی کڕیار',
    phoneNumber2: 'ژمارەی مۆبایل ٢',
    governorate: 'پارێزگا',
    address: 'ناونیشان',
    credit: 'باڵانس',
    shipOnly: 'تەنها گەیاندن',
    cancelReason: 'هۆکاری هەڵوەشاندنەوە',
    description: 'وردەکاری',
    verified: 'پشتڕاستکراوە',
    unverified: 'پشتڕاست نەکراوە',
    verifyFilterLabel: 'پاڵاوتنی پشتڕاستکردنەوە',
    staff: 'ستاف',
    balance: 'باڵانس',
    initialBalance: 'باڵانسی سەرەتایی',
    debit: 'قەرز',
    transactionType: 'جۆری مامەڵە',
    source: 'سەرچاوە',
    sourceId: 'ناسنامەی سەرچاوە',
    orderType: 'جۆری داواکاری',
    orderTypeName: 'ناوی جۆری داواکاری',
    phone2: 'مۆبایل 2',
    receivedDeliveryAmount: 'بڕی گەیاندنی وەرگیراو',
    preview: 'پێشبینین',
    linkUrl: 'لینک (URL)',
    qrCode: 'کۆدی QR',
    domain: 'دۆمەین',
    platform: 'پلاتفۆرم',
    invoiceNumber: 'ژمارەی پسوڵە',
    refundBy: 'گەڕاندنەوە لەلایەن',
    confirmDate: 'بەرواری پشتڕاستکردنەوە',
    fromDate: 'لە بەرواری',
    toDate: 'بۆ بەرواری',
    buyCost: 'تێچووی کڕین',
    intShipping: 'گەیاندنی نێودەوڵەتی',
    usdPrice: 'نرخی دۆلار',
    tlPrice: 'نرخی لیرەی تورکی',
    exchangeDate: 'بەرواری گۆڕینەوە',
    book: 'دەفتەر',
    fromBank: 'لە بانک',
    toBank: 'بۆ بانک',
    expenseAmount: 'بڕی خەرجی',
    iqdSell: 'فرۆشتنی دیناری عێراقی',
    iqdBuy: 'کڕینی دیناری عێراقی',
    tlSell: 'فرۆشتنی لیرەی تورکی',
    tlBuy: 'کڕینی لیرەی تورکی',
    aedSell: 'فرۆشتنی درهەمی ئیماراتی',
    aedBuy: 'کڕینی درهەمی ئیماراتی',
    cnySell: 'فرۆشتنی یوانی چینی',
    cnyBuy: 'کڕینی یوانی چینی',
    gbpSell: 'فرۆشتنی پاوەندی بەریتانی',
    gbpBuy: 'کڕینی پاوەندی بەریتانی',
    eurSell: 'فرۆشتنی یۆرۆ',
    eurBuy: 'کڕینی یۆرۆ',
    expenseType: 'جۆری خەرجی',
    supplierInvoiceNo: 'ژمارەی وەسڵی دابینکەر',
    supplier: 'دابینکەر',
    expenseDate: 'بەرواری خەرجی',
    noAbbreviation: 'ژمارە'
  },
  orders: {
    newOrdersTitle: 'داواکارییە نوێیەکان',
    pendingAnswerOrdersTitle: 'داواکارییە چاوەڕوانی وەڵامەکان',
    processedOrdersTitle: 'داواکارییە پرۆسەکراوەکان',
    canceledOrdersTitle: 'داواکارییە هەڵوەشێنراوەکان',
    processOrderTooltip: 'پرۆسەکردنی داواکاری',
    approveThisOrderTooltip: 'ڕەزامەندی لەسەر ئەم داواکارییە',
    returnToNewOrderTooltip: 'گەڕانەوە بۆ داواکارییە نوێیەکان',
    returnToShipOnlyTooltip: 'گەڕانەوە بۆ تەنها گەیاندن',
    errorOccurredProcessingOrder: 'هەڵەیەک ڕوویدا لە کاتی پرۆسەکردنی ئەم داواکارییە',
    errorOccurredSubmittingOrders: 'هەڵەیەک ڕوویدا لە کاتی ناردنی داواکارییەکان',
    couldNotFetchOrderDetails: 'نەتوانرا وردەکارییەکانی داواکاری وەربگیرێت',
    failedToCancelOrder: 'هەڵوەشاندنەوەی داواکاری سەرنەکەوت',
    sumOfSelectedOrdersLabel: 'کۆی داواکارییە هەڵبژێردراوەکان',
    failedToSendOrdersToIntShipment: 'ناردنی داواکارییەکان بۆ گەیاندنی نێودەوڵەتی سەرکەوتوو نەبوو',
    failedToSendOrdersToBranchDelivery: 'ناردنی داواکارییەکان بۆ گەیاندنی لق سەرکەوتوو نەبوو',
    failedToUnclearOrders: 'پاککردنەوەی داواکارییەکان سەرکەوتوو نەبوو',
    failedToMarkOrdersAsDelivered: 'نیشانکردنی داواکارییەکان وەک گەیشتوو سەرکەوتوو نەبوو',
    missingQrCodeForMessage: 'کۆدی QR بونی نییە بۆ: {list}. ماوەکە بە سەرکەوتوویی گەیشتن — کۆدی QR بۆ ئەمانە دروست بکە و دووبارە هەوڵ بدەرەوە.',
    customerHasLoanMustPayMessage: 'ئەم کڕیارە ({name}) قەرزی هەیە و دەبێت بەلایەنی کەم ${amount} بدات',
    returnToProcessedOrderTooltip: 'گەڕانەوە بۆ داواکارییە پرۆسەکراوەکان',
    ordersReturnedToNewOrderSection: 'داواکارییەکان گەڕێندرانەوە بۆ بەشی داواکارییە نوێیەکان',
    orderUpdatedTitle: 'داواکاری نوێکرایەوە',
    pleaseSelectOrderToPurchase: 'تکایە هەندێک داواکاری هەڵبژێرە بۆ کڕین',
    pleaseRefreshPageAndTryAgain: 'تکایە پەڕەکە نوێ بکەرەوە و دووبارە هەوڵبدەرەوە',
    pleaseCheckOrderToApprove: 'تکایە بۆ لانیکەم یەک داواکاری هەڵبژێرە بۆ ڕەزامەندی',
    onceConfirmedAllApproved: 'دوای دڵنیابوونەوە، هەموو داواکارییە هەڵبژێردراوەکان ڕەزامەندی لەسەر دەکرێت',
    viewOrderInvoiceConfirm: 'دەتەوێت وەسڵی ئەم داواکارییە ببینیت؟',
    pleaseSelectOrderToDelete: 'تکایە بۆ لانیکەم یەک داواکاری هەڵبژێرە بۆ سڕینەوە',
    deleteSelectedCanceledOrdersConfirm: 'هەموو داواکارییە هەڵوەشێنراوە هەڵبژێردراوەکان بسڕدرێنەوە؟ ئەمە ناتوانرێت لەم پەڕەیە بگەڕێندرێتەوە.',
    permanentlyDeleteTitle: 'سڕینەوەی هەمیشەیی؟',
    permanentlyDeleteCanceledOrdersConfirm: 'ئەمە داواکارییە هەڵوەشێنراوە هەڵبژێردراوەکان بە تەواوی لە بنکەدراوە دەسڕێتەوە — جیاواز لە "سڕینەوەی داواکارییە هەڵبژێردراوەکان"، ئەمە ناتوانرێت بگەڕێندرێتەوە. مێژووی مامەڵە و باڵانسی کڕیار کاریگەری لەسەر ناکات.',
    undoCancelOrderConfirm: 'گەڕاندنەوەی هەڵوەشاندنەوەی داواکاری، داواکاری دەگەڕێنێتەوە بۆ دۆخی پێشوو.',
    warehouseDeliveredOrdersTitle: 'داواکارییە گەیشتووەکان بۆ کۆگا',
    allOrdersTitle: 'هەموو داواکارییەکان',
    deliveredToErbilOrdersTitle: 'داواکارییە گەیشتووەکان بۆ هەولێر',
    purchasedOrdersTitle: 'داواکارییە کڕدراوەکان',
    approvedOrdersTitle: 'داواکارییە ڕەزامەندکراوەکان',
    internationalShipmentOrdersTitle: 'داواکارییەکانی گەیاندنی نێودەوڵەتی',
    pendingToBranchOrdersTitle: 'داواکارییە چاوەڕوانی لقەکان',
    refundedOrdersTitle: 'داواکارییە گەڕێندراوەکان',
    customerDeliveredOrdersTitle: 'داواکارییە گەیشتووەکان بۆ کڕیار',
    exportableOrdersTitle: 'داواکارییە هەناردەکراوەکان',
    warehousePassedOrdersTitle: 'داواکارییە تێپەڕیوەکانی کۆگا',
    purchaseHistoryTitle: 'مێژووی کڕین',
    viewShippingInvoiceTooltip: 'بینینی وەسڵی گەیاندن',
    generateQrCodeTooltip: 'دروستکردنی کۆدی QR',
    generateInvoiceTooltip: 'دروستکردنی وەسڵ',
    moveToDamageTooltip: 'گواستنەوە بۆ زیانلێکەوتوو',
    moveToReturnTooltip: 'گواستنەوە بۆ گەڕاوە',
    sendToCustomerTooltip: 'ناردن بۆ کڕیار',
    copyToNewOrderTooltip: 'کۆپیکردن بۆ داواکاری نوێ',
    refundThisOrderTooltip: 'گەڕاندنەوەی ئەم داواکارییە',
    addOrderNumberTooltip: 'زیادکردنی ژمارەی داواکاری',
    orderNumberAddedSuccessfully: 'ژمارەی داواکاری بە سەرکەوتوویی زیادکرا',
    addWarehouseDateTooltip: 'زیادکردنی بەرواری کۆگا',
    purchaseThisOrderTooltip: 'کڕینی ئەم داواکارییە',
    addBarcodeTooltip: 'زیادکردنی بارکۆد',
    deliverToPendingToBranchTooltip: 'گەیاندن بۆ چاوەڕوانی لق',
    sendToBranchDeliveryTooltip: 'ناردن بۆ گەیاندنی لق',
    deliverToBranchTooltip: 'گەیاندن بۆ لق',
    pleaseSelectOrderOrCustomer: 'تکایە بۆ لانیکەم یەک داواکاری یان کڕیار هەڵبژێرە!',
    selectedDifferentCustomers: 'تۆ کڕیاری جیاوازت هەڵبژاردووە',
    someOrdersAlreadyInvoiced: 'هەندێک لە داواکارییە هەڵبژێردراوەکان پێشتر وەسڵیان بۆ دروستکراوە',
    copyToNewOrderConfirmTitle: 'کۆپی بکرێت بۆ داواکاری نوێ؟',
    copyToNewOrderConfirmMessage: 'ئەمە داواکاری {id} هەڵدەوەشێنێتەوە، پارە بە تەواوی دەداتەوە بۆ کڕیار، و کۆپیایەکی نوێ لە داواکاری نوێکاندا دروست دەکات بۆ نرخدانەوە. بەردەوام دەبیت؟',
    ordersPurchasedSuccessfully: 'داواکارییەکان بە سەرکەوتوویی کڕدران',
    orderPurchasedSuccessfully: 'داواکارییەکە بە سەرکەوتوویی کڕدرا',
    sentSuccessfully: 'بە سەرکەوتوویی نێردرا',
    onceDeliveredPendingBranchWarning: 'دوای گەیاندن بۆ چاوەڕوانی لق، ناتوانیت ئەم داواکارییە بگەڕێنیتەوە بۆ ئەم قۆناغە!',
    confirmSendToBranchDelivery: 'داواکارییە هەڵبژێردراوەکان ڕاستەوخۆ دەنێردرێن بۆ گەیاندنی لق.',
    sortByOrder: 'داواکاری',
    sortByConfirm: 'دڵنیابوونەوە',
    sortByPurchase: 'کڕین',
    someOrdersNotMarkedDelivered: 'هەندێک داواکاری وەک گەیشتوو نیشان نەکرا',
    orderAlreadyInvoicedTitle: 'ئەم داواکارییە پێشتر وەسڵی بۆ دروستکراوە',
    confirmAttachToDeliveryRequest: 'داواکاری(یەکانی) هەڵبژێردراو دەپەیوەندرێن بە داواکاری گەیاندنی ئەم کڕیارە — ئەگەر داواکارییەکی چاوەڕوان نەبێت یەکێکی نوێ دروست دەکرێت.',
    moveToDamageConfirmTitle: 'گواستنەوە بۆ زیانلێکەوتوو؟',
    confirmMoveToDamage: 'دڵنیایت دەتەوێت ئەم داواکارییە بگوازیتەوە بۆ دۆخی زیانلێکەوتوو؟',
    moveToReturnConfirmTitle: 'گواستنەوە بۆ گەڕاوە؟',
    confirmMoveToReturn: 'دڵنیایت دەتەوێت ئەم داواکارییە بگوازیتەوە بۆ دۆخی گەڕاوە؟',
    editThisOrderTooltip: 'دەستکاریکردنی ئەم داواکارییە',
    addRefundNumberTooltip: 'زیادکردنی ژمارەی گەڕاندنەوە',
    onceSentWarning: 'دوای ناردن، ناتوانیت ئەم داواکارییە بگەڕێنیتەوە بۆ ئەم قۆناغە!',
    onceSentPluralWarning: 'دوای ناردن، ناتوانیت ئەم داواکارییانە بگەڕێنیتەوە بۆ ئەم قۆناغە!',
    confirmGenerateQrSendIntShipment: 'کۆدی QR بۆ داواکارییە هەڵبژێردراوەکان دروست دەکرێت و ڕاستەوخۆ دەنێردرێن بۆ گەیاندنی نێودەوڵەتی.',
    confirmSendDirectlyToBranchDelivery: 'ئەم داواکارییە ڕاستەوخۆ دەنێردرێت بۆ گەیاندنی لق. ناتوانیت بیگەڕێنیتەوە بۆ ئەم قۆناغە!',
    pendingShipmentTooltip: 'چاوەڕوانی گەیاندن',
    sendToIntShipmentTitle: 'ناردن بۆ گەیاندنی نێودەوڵەتی',
    returnToPurchaseTooltip: 'گەڕانەوە بۆ کڕین',
    takePhotoTooltip: 'وێنەگرتن',
    createCaseTooltip: 'دروستکردنی کەیس',
    pleaseAtLeastSelectOneOrder: 'تکایە بۆ لانیکەم یەک داواکاری هەڵبژێرە!',
    currentPageScopeNote: 'پەڕەی ئێستا',
    filtersToggleLabel: 'پاڵاوتنەکان',
    oncePendingShipmentedWarning: 'دوای دانانی لە چاوەڕوانی گەیاندندا، ناتوانیت ئەم داواکارییە بگەڕێنیتەوە بۆ ئەم قۆناغە!',
    confirmReturnToPurchasedSection: 'بەڕاستی دەتەوێت ئەم داواکارییە بگەڕێنیتەوە بۆ بەشی کڕدراو؟',
    damageOrdersTitle: 'داواکارییە زیانلێکەوتووەکان',
    returnOrdersTitle: 'داواکارییە گەڕاوەکان',
    cancelOrderTooltip: 'هەڵوەشاندنەوەی داواکاری',
    newExportOrdersTitle: 'داواکارییە نوێیەکانی هەناردەکردن',
    processedExportOrdersTitle: 'داواکارییە پرۆسەکراوەکانی هەناردەکردن',
    canceledExportOrdersTitle: 'داواکارییە هەڵوەشێنراوەکانی هەناردەکردن',
    approvedExportOrdersTitle: 'داواکارییە ڕەزامەندکراوەکانی هەناردەکردن',
    sentExportOrdersTitle: 'داواکارییە نێردراوەکانی هەناردەکردن',
    receivedExportOrdersTitle: 'داواکارییە وەرگیراوەکانی هەناردەکردن',
    exportHistoryTitle: 'مێژووی هەناردەکردن',
    refundedExportOrdersTitle: 'داواکارییە گەڕێندراوەکانی هەناردەکردن',
    processTooltip: 'پرۆسەکردن',
    cancelTooltip: 'هەڵوەشاندنەوە',
    approveTooltip: 'ڕەزامەندی',
    sendTooltip: 'ناردن',
    receiveTooltip: 'وەرگرتن',
    partialRefundTooltip: 'گەڕاندنەوەی بەشێک',
    fullRefundTooltip: 'گەڕاندنەوەی تەواو',
    approvedStatusTitle: 'ڕەزامەندی درا',
    sentStatusTitle: 'نێردرا',
    receivedStatusTitle: 'وەرگیرا',
    pendingToShipmentOrdersTitle: 'داواکارییە چاوەڕوانی گەیاندنەکان',
    shipmentThisOrderTooltip: 'گەیاندنی ئەم داواکارییە',
    onceShipmentedWarning: 'دوای گەیاندن، ناتوانیت ئەم داواکارییە بگەڕێنیتەوە بۆ ئەم قۆناغە!',
    notFoundOrdersTitle: 'داواکارییە نەدۆزراوەکان',
    trashTooltip: 'سڕینەوە',
    allowToSendTooltip: 'ڕێگەدان بە ناردن',
    convertToOrderTooltip: 'گۆڕین بۆ داواکاری',
    convertToOrderTitle: 'گۆڕین بۆ داواکاری',
    deliveredToErbilOption: 'گەیشتووەتە هەولێر',
    addedTitle: 'زیادکرا',
    orderCasesTitle: 'کەیسەکانی داواکاری',
    sendToStaffTooltip: 'ناردن بۆ ستاف',
    refundTooltip: 'گەڕاندنەوە',
    replaceTooltip: 'گۆڕینەوە',
    imagesTooltip: 'وێنەکان',
    orderCaseProgressTitle: 'پێشکەوتنی کەیسی داواکاری',
    convertedToOrderStatus: 'گۆڕدرا بۆ داواکاری',
    pendingStatus: 'چاوەڕوان',
    processingStatus: 'لە پرۆسەدایە',
    viewDetails: 'بینینی وردەکارییەکان',
    cancelThisOrder: 'پاشگەزبوونەوە لەم داواکارییە',
    sendToPendingAnswerTooltip: 'ناردن بۆ چاوەڕوانی وەڵام',
    sendToProcessTooltip: 'ناردن بۆ پرۆسەکردن',
    orderSort: 'ڕیزکردنی داواکاری',
    dateTypeLabel: 'جۆری ڕێکەوت',
    newestFirst: 'نوێترین یەکەم',
    oldestFirst: 'کۆنترین یەکەم',
    homeDelivery: 'گەیاندنی ماڵەوە',
    officeDelivery: 'گەیاندنی نووسینگە',
    sendThisOrderToProcess: 'ئەم داواکارییە بنێردرێت بۆ پرۆسەکردن؟',
    sendAllSelectedToProcess: 'هەموو داواکارییە هەڵبژێردراوەکان بنێردرێن بۆ پرۆسەکردن؟',
    sendToPendingAnswerConfirm: 'ناردن بۆ چاوەڕوانی وەڵام',
    pleaseSelectOrder: 'تکایە داواکارییەک هەڵبژێرە',
    warehousesPlaceholder: 'کۆگاکان',
    processThisOrderTooltip: 'پرۆسەکردنی ئەم داواکارییە',
    theOrderIsProcessed: 'داواکارییەکە پرۆسەکرا',
    editOrderInfoSection: 'دەستکاریکردنی زانیاری داواکاری',
    customerLockedHint: 'قفڵکراوە — بۆ گۆڕینی کڕیار، دووبارە دیاریکردنی کڕیاری داواکاری بەکاربهێنە',
    requestName: 'ناوی داواکاری',
    requestLink: 'لینکی داواکاری',
    uploadOrderImage: 'بارکردنی وێنەی داواکاری',
    requestDescription: 'وردەکاری داواکاری',
    editOrderPriceSection: 'دەستکاریکردنی نرخی داواکاری',
    itemPriceLabel: 'نرخی کاڵا ({unit})',
    discountedShippingPriceLabel: 'نرخی گەیاندن دوای داشکاندن ($)',
    discountLabel: 'داشکاندن ({unit})',
    deliveryIqdLabel: 'گەیاندن (دیناری عێراقی)',
    estimateTimeToArrivalLabel: 'کاتی خەملێنراوی گەیشتن (ڕۆژ)',
    customerProcessNoteLabel: 'تێبینی پرۆسەی کڕیار',
    uploadImage: 'بارکردنی وێنە',
    otherServiceNoteLabel: 'تێبینی خزمەتگوزاری تر',
    reason: 'هۆکار',
    bulkNewOrdersTitle: 'داواکاری کۆمەڵی نوێ',
    allItemsOrderedSuccessfully: 'هەموو کاڵاکان بە سەرکەوتوویی داواکرا!',
    customerRequiredError: 'کڕیار پێویستە',
    warehouseCountryLabel: 'کۆگا / وڵات',
    warehouseRequiredError: 'کۆگا پێویستە',
    itemNamePlaceholder: 'ناوی کاڵا',
    addRowButton: 'زیادکردنی ڕیز',
    countPlaceholder: 'ژمارە',
    numberOfRowsToAddHint: 'ژمارەی ڕیزەکان بۆ زیادکردن (0 یان بەتاڵ = 1)',
    itemsTotalLabel: '{count} کاڵا بە کۆی گشتی',
    sendToPurchaseLabel: 'ناردن بۆ کڕین',
    submitAllOrdersButton: 'ناردنی هەموو داواکارییەکان',
    removeRowTitle: 'لابردنی ڕیز',
    pickColorTitle: 'ڕەنگێک هەڵبژێرە',
    maxOrdersLimitError: 'دەتوانیت بەلایەنی زۆرەوە {max} داواکاری زیاد بکەیت لە یەک جاردا.',
    onlyRowsAddedLimitError: 'تەنها {count} ڕیز زیادکرا — سنووری {max} داواکاری تێپەڕا.',
    unsupportedImageTypeError: 'فایلی "{fileName}" جۆرێکی وێنەی پشتگیریکراو نییە. ڕێگەپێدراوەکان: {allowed}.',
    fileSizeLimitError: 'فایلی "{fileName}" لە سنووری 50 مێگابایت تێدەپەڕێت.',
    uploadingImagesProgress: 'بارکردنی وێنەکان {done}/{total}...',
    savingOrders: 'پاشەکەوتکردنی داواکارییەکان...',
    gifSizeLimitError: 'فایلی GIF "{fileName}" لە سنووری 2 مێگابایت تێدەپەڕێت. تکایە JPG یان PNG بەکاربهێنە.',
    imagesStillProcessingError: 'هەندێک وێنە هێشتا ئامادە دەکرێن. تکایە کەمێک چاوەڕێ بکە و دووبارە بینێرە.',
    uploadTooLargeError: 'قەبارەی بارکردنەکە بۆ سێرڤەر زۆر گەورەیە. تکایە وێنەی کەمتر یان بچووکتر بار بکە.',
    rowItemNameRequiredError: 'ڕیزی {row}: ناوی کاڵا پێویستە.',
    rowLinkRequiredError: 'ڕیزی {row}: لینک (URL) پێویستە.',
    rowQuantityMinError: 'ڕیزی {row}: بڕ دەبێت بەلایەنی کەم 1 بێت.',
    viewOrderDetailsTitle: 'بینینی وردەکاری داواکاری',
    itemPriceCurrencyLabel: 'نرخی کاڵا {code}',
    refundAmountLabel: 'بڕی گەڕاندنەوە',
    partialRefundsLabel: 'گەڕاندنەوە بەشییەکان',
    partialRefundAtBy: 'لە {date} لەلایەن {name}',
    newOrderTitle: 'داواکاری نوێ',
    itemOrderedSuccessfully: 'کاڵا بە سەرکەوتوویی داواکرا',
    urlFormatNotAcceptable: 'فۆرماتی لینک قبوڵ نییە',
    intShippingUsdLabel: 'گەیاندنی نێودەوڵەتی ($)',
    imageUrlOptionalLabel: 'لینکی وێنە (ئارەزوومەندانە)',
    urlWillBeUsedInsteadHint: 'لینک بەکاردەهێنرێت لە جیاتی بارکردنی فایل',
    purchaseBankLabel: 'بانکی کڕین',
    otherServiceSpecifyLabel: 'خزمەتگوزاری تر (تکایە دیاریبکە)',
    couponCodeRequiredError: 'ئەم خانەیە دەبێت کۆدی کوپۆنی تێدابێت',
    fileSizeExceedsError: '{field} نابێت لە {size} مێگابایت زیاتر بێت.',
    unsupportedImageTypeShort: 'جۆری وێنە پشتگیرینەکراوە. ڕێگەپێدراوەکان: {allowed}.',
    fileSizeLimitShort: 'فایلەکە لە سنووری ٥٠ مێگابایت تێدەپەڕێت.',
    uploadPhotoButton: 'بارکردنی وێنە',
    partialRefundInvoiceTitle: 'پسوڵەی گەڕاندنەوەی بەشی',
    newStatus: 'نوێ',
    updateShipOnlyTitle: 'نوێکردنەوەی تەنها گەیاندن',
    newShipOnlyTitle: 'تەنها گەیاندنی نوێ',
    orderedSuccessfully: 'بە سەرکەوتوویی داواکرا',
    fromDateGreaterThanTodayError: 'بەرواری دەستپێک دەبێت لە ئەمڕۆ گەورەتر بێت',
    toDateGreaterThanFromDateError: 'بەرواری کۆتایی دەبێت لە بەرواری دەستپێک گەورەتر بێت'
  },
  delivery: {
    orderDeliveryTitle: 'گەیاندنی داواکاری',
    changeStatusTooltip: 'گۆڕینی دۆخ',
    viewInvoiceTooltip: 'بینینی وەسڵ',
    viewCustomerOrdersImagesTooltip: 'بینینی داواکاری و وێنەکانی کڕیار',
    editDeliveryPriceTooltip: 'دەستکاریکردنی نرخی گەیاندن',
    deliveryRequestDeleteConfirm: 'ئەم داواکاری گەیاندنە بە یەکجاری دەسڕدرێتەوە.',
    deletedTitle: 'سڕایەوە',
    deliveryPriceIqdTitle: 'نرخی گەیاندن (دیناری عێراقی)',
    deliveryPricePlaceholder: 'نرخی گەیاندن',
    pleaseSelectAtLeastOneDeliveryRequest: 'تکایە بۆ لانیکەم یەک داواکاری گەیاندن هەڵبژێرە!',
    postStatus: 'بڵاوکردنەوە',
    holdStatus: 'ڕاگرتن',
    completeStatus: 'تەواوبوون',
    orderDeliveryInvoiceTitle: 'پسوڵەی گەیاندنی داواکاری',
    invoicedToLabel: 'پسوڵەکراوە بۆ',
    phone2Label: 'مۆبایل 2',
    detachTooltip: 'لابردن لەم داواکاری گەیاندنە',
    orderNumberColumn: 'ژمارەی داواکاری',
    totalOrdersLabel: 'کۆی داواکارییەکان:',
    totalUsdLabel: 'کۆی دۆلار:',
    iraqiDinarLabel: 'دیناری عێراقی:',
    totalIqdColonLabel: 'کۆی دیناری عێراقی:',
    attachedOrdersNotYetInvoiced: 'داواکاری لکاوەکان (هێشتا پسوڵە نەکراون)',
    orderColumn: 'داواکاری',
    productColumn: 'بەرهەم',
    detachConfirmTitle: 'ئەم پسوڵەیە لادەبرێت؟',
    detachConfirmText: '{invoice} چیتر بەشێک نابێت لەم داواکاری گەیاندنە. وەک پسوڵەی گەیاندنی ئاسایی دەمێنێتەوە و دەتوانرێت دووبارە لکێنرێتەوە.',
    deliveryInvoiceTitle: 'پسوڵەی گەیاندن',
    customerBalanceLabel: 'باڵانسی کڕیار:',
    deliveryMethodLabel: 'شێوازی گەیاندن:',
    pickupInOfficeLabel: 'وەرگرتن (لە نووسینگە)',
    payOnDeliveryLabel: 'پارەدان لە کاتی گەیاندن:',
    deliveryInvoicesTitle: 'پسوڵەکانی گەیاندن',
    invoiceSelectedCount: '{count} پسوڵە هەڵبژێردراوە',
    selectStatusLabel: 'دۆخ هەڵبژێرە',
    totalRecordsFooter: 'کۆی تۆمارەکان: {count}',
    totalPriceFooter: 'کۆی نرخ: {amount}',
    totalDeliveryPriceFooter: 'کۆی نرخی گەیاندن: {amount} دینار',
    deliveryPriceFooter: 'نرخی گەیاندن: {amount} دینار',
    viewShippingInvoicesTooltip: 'بینینی {count} پسوڵەی گەیاندن',
    thisDeliveryInvoiceWillBeDeleted: 'ئەم پسوڵەی گەیاندنە بە تەواوی سڕدرێتەوە.',
    pleaseSelectAtLeastOneDeliveryInvoice: 'تکایە بەلایەنی کەم یەک پسوڵەی گەیاندن هەڵبژێرە!',
    markAllSelectedInvoicesAsReceivedConfirm: 'ئەمە هەموو پسوڵە گەیاندنە هەڵبژێردراوەکان وەک وەرگیراو نیشان دەدات.',
    unmarkAllSelectedInvoicesAsReceivedConfirm: 'ئەمە نیشانی وەرگیراو لە هەموو پسوڵە گەیاندنە هەڵبژێردراوەکان لادەبات (بڕ و بەرواری وەرگیراو سڕدرێتەوە).',
    partialReceivedStatus: 'بەشێکی وەرگیراو',
    payOnDeliveryIqdLabel: 'پارەدان لە کاتی گەیاندن (دیناری عێراقی)',
    pickupLabel: 'وەرگرتن',
    notConfirmedLabel: 'دووپات نەکراوەتەوە',
    requestDeliveryTitle: 'داواکاری گەیاندن',
    customerRequiredLabel: 'کڕیار*',
    noteOptionalLabel: 'تێبینی (ئارەزوومەندانە)',
    changeStatusTitle: 'گۆڕینی دۆخ',
    requestsSelectedSuffix: 'داواکاری هەڵبژێردراوە',
    invoiceColonPrefix: 'پسوڵە:',
    custNoteColumn: 'تێبینی کڕیار',
    createdColumn: 'دروستکراوە'
  },
  invoice: {
    shippingInvoiceTitle: 'وەسڵی گەیاندن',
    receivedInvoicesTitle: 'وەسڵە وەرگیراوەکان',
    invoiceTooltip: 'وەسڵ',
    recordPaymentTooltip: 'تۆمارکردنی پارەدان',
    logsTooltip: 'تۆمارەکان',
    failedToDeleteInvoice: 'سڕینەوەی وەسڵ سەرکەوتوو نەبوو — نەسڕایەوە.',
    somethingWentWrong: 'شتێک هەڵەی ڕوویدا!',
    pleaseSelectAtLeastOneInvoice: 'تکایە بۆ لانیکەم یەک وەسڵ هەڵبژێرە!',
    ordersInvoiceTitle: 'وەسڵی داواکارییەکان',
    creditInvoiceTitle: 'وەسڵی باڵانس',
    confirmMarkAllPaid: 'هەموو وەسڵە هەڵبژێردراوەکان وەک بە تەواوی پارەدراو نیشان دەدرێن.',
    confirmMarkAllReceived: 'هەموو وەسڵە هەڵبژێردراوەکان وەک وەرگیراو نیشان دەدرێن.',
    confirmUnmarkAllReceived: 'نیشانەی وەرگرتن لە هەموو وەسڵە هەڵبژێردراوەکان لادەبرێت (خاوەن، بەرواری وەرگرتن و بڕی وەرگیراو پاک دەکرێنەوە).',
    cashReceivedInDaysLabel: 'پارەی نەقدی وەرگیراو لەم ڕۆژانەدا:',
    cashReceivedInDaysHint: 'تەنها ئەو پارە نوێیەی لە بەروارە دیاریکراوەکانی وەرگرتندا ڕادەست کراوە. بە پێچەوانەی کۆی وەرگیراو، کاتێک وەسڵ دواتر دووبارە وەردەگیرێتەوە ناگۆڕێت.',
    confirmToggleOutOffice: 'دۆخی "دەرەوەی نووسینگە" بۆ وەسڵە هەڵبژێردراوەکان دەگۆڕدرێت.',
    pleaseSelectAtLeastTwoPaidInvoices: 'تکایە بۆ لانیکەم دوو وەسڵی پارەدراو هەڵبژێرە بۆ تێکەڵکردن!',
    paidStatus: 'پارەدراوە',
    partialPaidStatus: 'بەشێک پارەدراوە',
    unpaidStatus: 'پارەنەدراوە',
    receivedAtOption: 'بەرواری وەرگرتن',
    singleOption: 'تاک',
    batchOption: 'کۆمەڵە',
    digitalOption: 'دیجیتاڵ',
    officeOption: 'نووسینگە',
    manualOption: 'دەستی',
    refundExistsOption: 'گەڕاندنەوە هەیە',
    noRefundOption: 'گەڕاندنەوە نییە',
    generateInvoiceTitle: 'دروستکردنی پسوڵە',
    customerLabel: 'کڕیار: {name}',
    phoneNumberLabel: 'ژمارەی مۆبایل: {phone}',
    ordersLabel: 'داواکارییەکان',
    shipmentLabel: 'گەیاندن',
    handlingFeeLabel: 'کرێی هەڵگرتن',
    totalPriceLabel: 'کۆی نرخ',
    totalIqdLabel: 'کۆی دیناری عێراقی',
    paidAmountLabel: 'بڕی دراو',
    remainingAfterSelectedOrders: 'ماوە دوای پسوڵەکانی داواکارییە هەڵبژێردراوەکان: {usd} / {iqd} دینار',
    remainingFromOtherPartialInvoices: 'ماوە لە پسوڵەی تری بەشی دراو: {usd} / {iqd} دینار',
    loadingText: 'باردەکرێت...',
    balanceLabel: 'باڵانس',
    remainingBalanceLabel: 'باڵانسی ماوە',
    shippingInvoiceNoLabel: 'ژمارەی پسووڵەی گەیاندن:',
    customerOutOfficeTotalNote: 'کۆی گشتی دەرەوەی نووسینگە بۆ ئەم کڕیارە: {amount}',
    cashAndView: 'نەقد و بینین',
    outOfficeButton: 'دەرەوەی نووسینگە',
    viewButton: 'بینین',
    deliveryButton: 'گەیاندن',
    cancelStatus: 'هەڵوەشاندنەوە',
    notPaidWatermark: 'نەدراوە',
    invoiceNoteLabel: 'تێبینی پسوڵە:',
    secondaryInvoiceGeneratedNote: 'پسوڵەی لاوەکی بۆ ئەم داواکارییە دروستکراوە',
    invoiceSavedNoPreview: 'پسوڵە پاشکەوتکرا بەڵام نەتوانرا پێشبینین بکرێت (ناسنامەی پسوڵە نییە).',
    invoiceGeneratedSuccessfully: 'پسوڵە بە سەرکەوتوویی دروستکرا',
    requestFailed: 'داواکاری سەرکەوتوو نەبوو',
    invoiceSavedNoAttach: 'پسوڵە پاشکەوتکرا بەڵام نەتوانرا بە گەیاندنەوە بلکێنرێت (ناسنامەی پسوڵە نییە).',
    attachFailed: 'لکاندن سەرکەوتوو نەبوو',
    invoiceCreatedCouldNotAttach: 'پسوڵە دروستکرا، بەڵام نەتوانرا بلکێنرێت: {msg}',
    alreadyAttachedNote: '{list} پێشتر بە داواکاری گەیاندنەوە لکاوە — دووبارە نەلکێنرا.'
  },
  navbar: {
    creditLabel: 'باڵانس:',
    addBalance: 'زیادکردنی باڵانس',
    subscription: 'بەشداریکردن',
    exchangeRateLabel: 'نرخی ئاڵوگۆڕ:',
    capital: 'سەرمایە',
    verifyAccountButton: 'هەژمارەکەت پشتڕاست بکەرەوە',
    printLogs: 'تۆماری چاپکردن',
    warehouseDatePassedOrders: 'داواکارییەکانی بەسەرچووی بەرواری کۆگا',
    warehouseDateLabel: 'بەرواری کۆگا:',
    notifications: 'ئاگادارییەکان'
  },
  sidebar: {
    toggleAllNavigations: 'کردنەوە/داخستنی هەموو لیستەکان',
    dashboard: 'داشبۆرد',
    statisticsDashboard: 'داشبۆردی ئامار',
    loanedCustomerTitle: 'کڕیاری قەرزدار',
    customerPricesTitle: 'نرخەکانی کڕیار',
    orderCasesProgressTitle: 'پێشکەوتنی کەیسی داواکارییەکان',
    orderTypesTitle: 'جۆرەکانی داواکاری',
    chargeBalanceTitle: 'باڵانس زیادکردن',
    shipOnlyNewTitle: 'تەنها گەیاندن (نوێ)',
    orderInvoicesTitle: 'پسوڵەی داواکارییەکان',
    shippingInvoicesTitle: 'پسوڵەی گەیاندن',
    creditInvoicesTitle: 'پسوڵەی باڵانس',
    partialRefundInvoicesTitle: 'پسوڵەی گەڕاندنەوەی بەشی',
    orders: 'داواکارییەکان',
    tools: 'ئامرازەکان',
    export: 'هەناردەکردن',
    import: 'هاوردەکردن',
    delivery: 'گەیاندن',
    invoices: 'وەسڵەکان',
    finance: 'دارایی',
    cases: 'کەیسەکان',
    customers: 'کڕیارەکان',
    reports: 'ڕاپۆرتەکان',
    mobileApp: 'ئەپی مۆبایل',
    admin: 'بەڕێوەبەری'
  },
  warehouse: {
    warehousesTitle: 'کۆگاکان',
    updateWarehouseTitle: 'نوێکردنەوەی کۆگا',
    warehouseUpdatedSuccessfully: 'کۆگا بە سەرکەوتوویی نوێکرایەوە',
    estimateDaysLabel: 'ڕۆژی خەمڵێنراو (ماوەی گەیاندن)',
    houseNumberLabel: 'ژمارەی ماڵ',
    stateProvinceLabel: 'ویلایەت - پارێزگا',
    prefixLabel: 'پێشگر',
    flagCodeHint: 'کۆدی ئاڵا (٢ پیتی ISO، وەک: tr, us, ae, cn, gb, de)',
    customCodeLabel: 'کۆدی تایبەت',
    transportationTypesLabel: 'جۆرەکانی گواستنەوە',
    defaultImageLabel: 'وێنەی بنەڕەتی'
  },
  user: {
    staffTitle: 'ستاف',
    totalIncomeAddLabel: 'کۆی داهات (زیادکردن +)',
    totalOutgoingCashBackLabel: 'کۆی دەرچوو (گەڕاندنەوەی کاش -)',
    verifiedAtLabel: 'پشتڕاستکرایەوە لە',
    customersTitle: 'کڕیارەکان',
    editCustomerTooltip: 'دەستکاریکردنی کڕیار',
    customerTransactionTooltip: 'مامەڵەی کڕیار',
    customerTransactionsTitle: 'مامەڵەکانی {name}',
    removeFilterButton: 'لابردنی فلتەر',
    openingBalanceLabel: 'باڵانسی کردنەوە',
    updateCustomerTitle: 'نوێکردنەوەی کڕیار',
    codEnabledLabel: 'پارەدان لە کاتی گەیاندن',
    codEnabledHint: 'ڕێگە بدە بەم کڕیارە داواکاری پەسند بکات بەبێ باڵانسی کیف',
    block: 'بلۆککردن',
    unblock: 'لابردنی بلۆک',
    editStaffTooltip: 'دەستکاریکردنی ستاف',
    resetPasswordTooltip: 'ڕێستکردنەوەی وشەی نهێنی',
    resetPasswordSuccessfully: 'وشەی نهێنی بە سەرکەوتوویی ڕێستکرایەوە',
    blockThisUserTooltip: 'بلۆککردنی ئەم بەکارهێنەرە',
    unblockThisUserTooltip: 'لابردنی بلۆکی ئەم بەکارهێنەرە',
    notAllowed: 'ڕێگەپێنەدراوە',
    cannotResetOwnPassword: 'ناتوانیت وشەی نهێنی خۆت لێرە ڕێستبکەیتەوە، تەنها دەتوانیت وشەی نهێنی کەسانی تر ڕێستبکەیتەوە',
    personalInformation: 'زانیاری کەسی',
    updateCoverImageButton: 'نوێکردنەوەی وێنەی سەرپۆش',
    fullName: 'ناوی تەواو',
    addCustomerTitle: 'زیادکردنی کڕیار',
    customerFullNameLabel: 'ناوی تەواوی کڕیار',
    fullNameTwoWordsError: 'ناوی تەواو دەبێت لانیکەم دوو وشە بێت کە بە بۆشایی جیاکراونەتەوە',
    addStaffTitle: 'زیادکردنی ستاف',
    staffAddedSuccessfully: 'ستاف بە سەرکەوتوویی زیادکرا',
    passwordDoNotMatch: 'وشەی نهێنی یەکسان نییە',
    phoneMustStartWith964Error: 'ژمارەی تەلەفۆن دەبێت بە +964 دەست پێبکات',
    updateStaffTitle: 'نوێکردنەوەی ستاف',
    staffUpdatedSuccessfully: 'ستاف بە سەرکەوتوویی نوێکرایەوە',
    changePasswordTitle: 'گۆڕینی وشەی نهێنی',
    currentPassword: 'وشەی نهێنی ئێستا',
    newPassword: 'وشەی نهێنی نوێ',
    confirmPassword: 'دووپاتکردنەوەی وشەی نهێنی',
    changeSecretKeyTitle: 'گۆڕینی کلیلی نهێنی',
    currentSecret: 'کلیلی نهێنی ئێستا',
    newSecret: 'کلیلی نهێنی نوێ',
    confirmSecret: 'دووپاتکردنەوەی کلیلی نهێنی',
    createSecretKeyTitle: 'دروستکردنی کلیلی نهێنی',
    secretKey: 'کلیلی نهێنی',
    companyInfoTitle: 'زانیاری کۆمپانیا',
    companyName: 'ناوی کۆمپانیا',
    companyEmail: 'ئیمەیلی کۆمپانیا',
    companyAddress: 'ناونیشانی کۆمپانیا',
    confirmPasswordNotMatch: 'دووپاتکردنەوەی وشەی نهێنی یەکناگرێتەوە',
    passwordChangedSuccessfully: 'وشەی نهێنی بە سەرکەوتوویی گۆڕدرا',
    currentPasswordIncorrect: 'وشەی نهێنی ئێستا هەڵەیە',
    profileMustBeImage: 'وێنەی پرۆفایل دەبێت وێنە بێت',
    coverMustBeImage: 'وێنەی کەڤەر دەبێت وێنە بێت',
    secretKeyIncorrect: 'کلیلی نهێنی ئێستا هەڵەیە',
    secretKeyChangedSuccessfully: 'کلیلی نهێنی بە سەرکەوتوویی گۆڕدرا',
    currentSecretKeyRequired: 'کلیلی نهێنی ئێستا پێویستە',
    newSecretKeyRequired: 'کلیلی نهێنی نوێ پێویستە',
    confirmSecretKeyRequired: 'دووپاتکردنەوەی کلیلی نهێنی پێویستە',
    confirmSecretNotMatch: 'دووپاتکردنەوەی کلیلی نهێنی یەکناگرێتەوە',
    secretKeyCreatedSuccessfully: 'کلیلی نهێنی بە سەرکەوتوویی دروستکرا',
    alreadyHaveSecretKey: 'تۆ پێشتر کلیلێکی نهێنیت هەیە',
    secretKeyRequired: 'کلیلی نهێنی پێویستە',
    companyInfoUpdatedSuccessfully: 'زانیاری کۆمپانیا بە سەرکەوتوویی نوێکرایەوە',
    customerSubscriptionsTitle: 'بەشداریکردنەکانی کڕیار',
    editSubscriptionTooltip: 'دەستکاریکردنی بەشداریکردن',
    deleteCustomerSubscriptionTooltip: 'سڕینەوەی بەشداریکردنی کڕیار',
    pleaseSelectAtLeastOneSubscriptionToDelete: 'تکایە بۆ لانیکەم یەک بەشداریکردنی کڕیار هەڵبژێرە بۆ سڕینەوە',
    deleteCustomerSubscriptionConfirm: 'بەشداریکردنی کڕیار بسڕدرێتەوە: {name}؟',
    deleteAllCustomerSubscriptionsConfirm: 'هەموو بەشداریکردنە هەڵبژێردراوەکانی کڕیار بسڕدرێنەوە؟',
    customerCreditTitle: 'باڵانسی کڕیار',
    onceDeletedCreditWarning: 'دوای سڕینەوە، ناتوانیت ئەم باڵانسە بگەڕێنیتەوە!',
    onceDeletedCashBackWarning: 'دوای سڕینەوە، ناتوانیت ئەم کاش باکە بگەڕێنیتەوە!',
    customerDefaultPricesTitle: 'نرخە بنەڕەتییەکانی کڕیار'
  },
  reports: {
    salesReportTitle: 'ڕاپۆرتی فرۆشتن',
    gainedReportTitle: 'ڕاپۆرتی قازانج',
    expensesReportTitle: 'ڕاپۆرتی خەرجی',
    invoicesReportTitle: 'ڕاپۆرتی وەسڵەکان',
    orderCostsReportTitle: 'ڕاپۆرتی تێچووی داواکارییەکان',
    buysReportTitle: 'ڕاپۆرتی کڕین',
    customersReportTitle: 'ڕاپۆرتی کڕیارەکان',
    customerInvoicesReportTitle: 'ڕاپۆرتی وەسڵی کڕیاران',
    deliveryReportTitle: 'ڕاپۆرتی گەیاندن',
    dailyRevenueReportTitle: 'ڕاپۆرتی داهاتی ڕۆژانە',
    deliveredReportTitle: 'ڕاپۆرتی گەیشتوو',
    profitReportTitle: 'ڕاپۆرتی قازانج',
    unpaidArrivedInvoicesTitle: 'وەسڵە گەیشتووەکانی پارەنەدراو',
    unpaidReceivedInvoicesTitle: 'وەسڵە وەرگیراوەکانی پارەنەدراو',
    ordersReportTitle: 'ڕاپۆرتی داواکارییەکان',
    revenueReportTitle: 'ڕاپۆرتی داهات',
    orderStatusReportTitle: 'ڕاپۆرتی دۆخی داواکارییەکان',
    numberOfOrders: 'ژمارەی داواکارییەکان',
    numberOfRequests: 'ژمارەی داواکارییەکان',
    totalRequests: 'کۆی داواکارییەکان',
    totalBuy: 'کۆی کڕین',
    totalExpenses: 'کۆی خەرجییەکان',
    totalSales: 'کۆی فرۆشتن',
    totalGained: 'کۆی قازانج',
    staffMember: 'ئەندامی ستاف',
    paymentStatus: 'دۆخی پارەدان',
    count: 'ژمارە',
    paid: 'پارەدراو',
    transportation: 'گواستنەوە',
    totalCost: 'کۆی تێچوو',
    net: 'پاکی',
    totalRevenue: 'کۆی داهات',
    orderCount: 'ژمارەی داواکاری',
    request: 'داواکاری',
    exchangeDifference: 'جیاوازی ئاڵوگۆڕ',
    shippingCost: 'تێچووی گەیاندن',
    deliveryIqd: 'گەیاندن (دینار)',
    totalGain: 'کۆی قازانج',
    apply: 'جێبەجێکردن',
    printReport: 'چاپکردنی ڕاپۆرت',
    pleaseSelectFromToDate: 'تکایە بەرواری دەستپێک و کۆتایی هەڵبژێرە',
    failedToLoadReport: 'بارکردنی ڕاپۆرت سەرکەوتوو نەبوو',
    pleaseSelectStatusFromToDate: 'تکایە دۆخێک و بەرواری دەستپێک و کۆتایی هەڵبژێرە',
    failedToLoadInvoices: 'بارکردنی وەسڵەکان سەرکەوتوو نەبوو',
    customerWhoPlacedOrders: 'ئەو کڕیارەی داواکاری(یەکانی) کردووە',
    orderCountSubLabelSuffix: '= داواکاری بەو دۆخە هەڵبژێردراوە، لەلایەن ئەم کڕیارە لە ماوەکەدا',
    periodColon: 'ماوە:',
    acrossAllCustomers: 'بۆ هەموو کڕیارەکان',
    notPaidHeader: 'پارەنەدراو',
    notPaidSubLabel: 'وەسڵ بە بڕی پارەدراوی 0',
    partialPaidHeader: 'بەشێکی پارەدراو',
    partialPaidSubLabel: 'وەسڵ بە پارەدانی نێوان 0 و کۆی گشتی',
    paidSubLabel: 'وەسڵ بە پارەدانی یەکسان یان زیاتر لە کۆی گشتی',
    equalsInvoiceCount: '= ژمارەی وەسڵەکان',
    equalsSigmaInvoiceAmount: '= کۆی بڕی وەسڵەکان',
    equalsSigmaAmountPaid: '= کۆی بڕی پارەدراو',
    allCustomersOption: 'هەموو کڕیارەکان',
    telColonPrefix: 'تەلەفۆن: ',
    totalShippingCardTitle: 'کۆی گشتی گەیاندن',
    equalsSigmaShippingCost: '= کۆی تێچووی گەیاندنی داواکاری گەیشتوو لە ماوەکەدا',
    totalShipzoneFeeCardTitle: 'کۆی گشتی کرێی ShipZone',
    equalsSigmaShipzoneServiceFee: '= کۆی کرێی خزمەتگوزاری ShipZone بۆ داواکاری گەیشتوو لە ماوەکەدا',
    totalOrders: 'کۆی داواکارییەکان',
    grandTotal: 'کۆی گشتی',
    orderStatusStageHint: 'دۆخ/قۆناغی داواکاری',
    equalsCountOrdersWithStatus: '= ژمارەی داواکارییەکان بەم دۆخە',
    equalsSigmaOrderAmount: '= Σ بڕی داواکاری',
    qtyShipTotalPerCountryHint: 'بڕ = N؛ گەیاندن = Σ گەیاندن (S)؛ کۆی گشتی = Σ بڕ (A) بۆ ئەم وڵاتە',
    requestsGroupedByCountryHint: 'داواکارییەکان بەپێی وڵاتی مەبەست کۆکراونەتەوە',
    ordersGroupedByCountryHint: 'داواکارییەکان بەپێی وڵاتی مەبەست کۆکراونەتەوە',
    equalsCountBuyRequestsInCountry: '= ژمارەی داواکاری کڕین لەم وڵاتە',
    equalsSigmaOrderAmountPreDiscount: '= Σ بڕی داواکاری (پێش داشکاندن)',
    equalsSigmaDiscountApplied: '= Σ داشکاندنی جێبەجێکراو',
    groupedByTransportationMethodHint: 'کۆکراوەتەوە بەپێی شێوازی گواستنەوە',
    equalsCountOrdersUsingTransportation: '= ژمارەی داواکارییەکان کە ئەم شێوازی گواستنەوەیە بەکاردەهێنن',
    equalsSigmaOrderCostPreDiscount: '= Σ تێچووی داواکاری (پێش داشکاندن)',
    equalsSigmaRevenueCollected: '= Σ داهاتی کۆکراوە بۆ ئەم شێوازی گواستنەوەیە',
    sigmaDeliveriesSigmaIqdHint: 'Σ گەیاندنەکان، Σ دیناری عێراقی',
    equalsCountOrdersInCountry: '= ژمارەی داواکارییەکان لەم وڵاتە',
    equalsSigmaOrderAmountForCountry: '= Σ بڕی داواکاری بۆ ئەم وڵاتە',
    employeeWhoRecordedExpenseHint: 'ئەو کارمەندەی خەرجییەکەی تۆمارکردووە',
    equalsSigmaExpenseAmountByStaff: '= Σ بڕی خەرجی تۆمارکراو لەلایەن ئەم کارمەندە',
    sigmaAAcrossAllStaffHint: 'ΣA بۆ هەموو کارمەندان',
    accountStatusActiveInactiveHint: 'دۆخی هەژمار: چالاک / ناچالاک',
    equalsCustomersWithStatusInPeriod: '= کڕیارانی بەم دۆخە، تۆمارکراو لە ماوەکەدا',
    totalRegistered: 'کۆی تۆمارکراوان',
    invoiceStatusHint: 'دۆخی پسوڵە: نەدراوە / بەشێک / دراوە',
    equalsInvoicesWithStatus: '= پسوڵەکان بەم دۆخە',
    totalShipmentCardTitle: 'کۆی گەیاندن',
    totalTaxCardTitle: 'کۆی باج',
    invoiceShipmentCardTitle: 'گەیاندنی پسوڵە',
    netIncomeCardTitle: 'داهاتی رەسەن',
    equalsSigmaShipmentCost: '= Σ تێچووی گەیاندن',
    equalsSigmaShipzoneFeeCard: '= Σ کرێی شیپ زۆن',
    equalsSigmaTaxCollected: '= Σ باجی کۆکراوە',
    equalsSigmaShipmentAmountInvoiced: '= Σ بڕی گەیاندنی پسوڵەکراو بۆ کڕیاران',
    equalsSigmaRefundedAmountCard: '= Σ بڕی گەڕاوە',
    equalsSigmaBusinessExpenses: '= Σ خەرجی بازرگانی',
    equalsRevenueAfterRefundsFeesBeforeExpenses: '= داهات دوای گەڕانەوە/کرێ، پێش خەرجییەکان',
    orderDateHint: 'بەرواری داواکاری',
    orderRequestIdHint: 'ژمارەی داواکاری',
    equalsItemPriceLocalCurrency: '= نرخی کاڵا بە دراوی ناوخۆیی',
    currencyOfPHint: 'دراوی P (سور = $، شین = هی تر)',
    equalsUnitsOnOrder: '= ژمارەی یەکەکان لەم داواکارییە',
    equalsBuyCostUsd: '= تێچووی کڕین بە دۆلار',
    equalsPerUnitExchangeMargin: '= قازانجی ئاڵوگۆڕ بۆ هەر یەکە؛ × Q کاتێک Q > 1',
    equalsPerUnitShippingCost: '= تێچووی گەیاندن بۆ هەر یەکە؛ × Q کاتێک Q > 1',
    equalsDeliveryFeeIqd: '= کرێی گەیاندن بە دیناری عێراقی',
    equalsRowGainApprox: '= قازانجی ئەم ڕیزە نزیکەی (B + C) × Q',
    totalRevenueAcrossRowsHint: 'ΣB·Q, ΣC·Q, ΣD, ΣE بۆ هەموو ڕیزەکان',
    totalRevenueFooterLabel: 'کۆی داهات:',
    businessExpensesFooterLabel: 'خەرجی بازرگانی:',
    equalsSigmaBusinessExpensesInPeriod: '= Σ خەرجی بازرگانی لە ماوەکەدا',
    netGainAfterExpensesFooterLabel: 'قازانجی ڕەسەن (دوای خەرجییەکان):',
    equalsCountOrdersInPeriod: '= ژمارەی داواکارییەکان لە ماوەکەدا',
    equalsSigmaPurchaseBuyCost: '= Σ تێچووی کڕین',
    equalsSigmaSalesRevenue: '= Σ داهاتی فرۆشتن'
  },
  mobileApp: {
    aboutAppSectionTitle: 'بەشی دەربارەی ئەپ',
    helpCenterSectionTitle: 'بەشی سەنتەری یارمەتی (پرسیارە دووبارەکان)',
    homeSliderTitle: 'سلایدەری سەرەکی (ئەپ)',
    addNewHomeSliderButton: 'زیادکردنی سلایدەری نوێ',
    homeBannerTitle: 'بانەری سەرەکی مۆبایل (ئەپ)',
    popularWebsiteTitle: 'ماڵپەڕە بەناوبانگەکان (ئەپ)',
    updatePopularWebsiteTitle: 'نوێکردنەوەی ماڵپەڕی بەناوبانگ',
    addNewPopularWebsiteTitle: 'زیادکردنی ماڵپەڕی بەناوبانگی نوێ',
    globalWebsiteGroupTitle: 'گروپی ماڵپەڕی جیهانی (ئەپ)',
    websitesAppTitle: 'ماڵپەڕەکان (ئەپ)',
    addNewGlobalWebsiteButton: 'زیادکردنی ماڵپەڕی جیهانی نوێ',
    updateGlobalWebsiteTitle: 'نوێکردنەوەی ماڵپەڕی جیهانی',
    uploadLogo: 'بارکردنی لۆگۆ',
    forceUpdateTitle: 'نوێکردنەوەی زۆرەملێ',
    linksTitle: 'لینکەکان',
    ourAddressTitle: 'ناونیشانمان',
    updateOurAddressTitle: 'نوێکردنەوەی ناونیشانمان',
    addNewOurAddressTitle: 'زیادکردنی ناونیشانی نوێمان',
    customerAlreadyInList: 'کڕیار پێشتر لە لیستەکەدایە',
    pleaseSelectCustomer: 'تکایە کڕیارێک هەڵبژێرە',
    pleaseEnterTitle: 'تکایە ناونیشان بنووسە',
    pleaseEnterBody: 'تکایە ناوەڕۆک بنووسە'
  },
  admin: {
    couponsTitle: 'کۆپۆنەکان',
    editPercentageTooltip: 'دەستکاریکردنی ڕێژە',
    giveToCustomerTooltip: 'دانی بە کڕیار',
    onceDeletedCouponWarning: 'دوای سڕینەوە، ناتوانیت ئەم کۆپۆنە بگەڕێنیتەوە!',
    orderLogTitle: 'تۆماری داواکارییەکان',
    viewStaffTooltip: 'بینینی ستاف',
    viewOrderTooltip: 'بینینی داواکاری',
    viewCustomerTooltip: 'بینینی کڕیار',
    activityLogTitle: 'تۆماری چالاکی',
    shipZoneFeePricesTitle: 'نرخی کرێی شیپ زۆن',
    suppliersTitle: 'دابینکەرەکان',
    rolesTitle: 'ڕۆڵەکان',
    assignPermissionTooltip: 'دیاریکردنی مۆڵەت',
    settingsTitle: 'ڕێکخستنەکان',
    securitySection: 'ئاسایش',
    profileSection: 'پرۆفایل',
    onlinePaymentSection: 'پارەدانی ئۆنلاین',
    staleOrdersSection: 'داواکارییە وەستاوەکان',
    requireSecretKeyLabel: 'داوای کلیلی نهێنی بۆ پەڕەی هەستیار',
    lockFullNameEditLabel: 'قوفڵکردنی دەستکاریکردنی ناوی تەواو (مۆبایل) — کاتێک ناوی یەکەم و کۆتایی کڕیار دانرا، ئیتر ناتوانێت لە ئەپی مۆبایلەوە بیگۆڕێت',
    allowChangingCanceledStatusLabel: 'ڕێگەدان بە گۆڕینی دۆخی داواکارییە هەڵوەشێنراوەکان (ئەم بژاردەیە بکوژێنەوە بۆ قوفڵکردنی هەر گۆڕانێکی تر)',
    autoCreateShippingInvoicesLabel: 'دروستکردنی خۆکارانەی وەسڵی گەیاندن بۆ داواکارییە گەیشتووەکان لە کاتی زیادکردنی باڵانس (داواکارییەکان هەمیشە لە کاتی ڕەزامەندیدا وەسڵیان دەبێت، و زیادکردنی باڵانس هەمیشە هەر وەسڵێکی هەبوو دادەخات؛ ئەم بژاردەیە تەنها کۆنترۆڵی ئەوە دەکات کە ئایا زیادکردنی باڵانسی نوێ لە ڕێگەی FIB/QI/نووسینگە بە شێوەیەکی خۆکارانە وەسڵ بۆ داواکارییە گەیشتووەکانی بێ وەسڵ دروست دەکات یان دەبڕدرێتەوە، یان چاوەڕوانی ستاف دەکات بۆ دروستکردنی دەستی لە ڕێگەی دروستکردنی وەسڵ',
    enableOnlinePaymentLabel: 'چالاککردنی پارەدانی ئۆنلاین (FIB، QiCard، FastPay، ZainCash) بۆ زیادکردنی باڵانس و پارەدانی داواکاری — ئەم بژاردەیە بکوژێنەوە بۆ بلۆککردنی هەموو شێوازەکانی پارەدانی ئۆنلاین لە هەموو ئەپەکەدا. پارەدان لە کاتی گەیاندندا هەرگیز کاریگەری لەسەر ئەم ڕێکخستنە نابێت.',
    fibCommissionRateLabel: 'ڕێژەی کۆمیسیۆنی FIB (%)',
    qiCommissionRateLabel: 'ڕێژەی کۆمیسیۆنی کارتی QI (%)',
    autoCancelStaleOrdersLabel: 'هەڵوەشاندنەوەی خۆکارانەی داواکارییە گیرکراوەکان لە دۆخی داواکاری نوێ یان پرۆسەکراو',
    hoursBeforeAutoCancelLabel: 'کاتژمێر پێش هەڵوەشاندنەوەی خۆکارانە',
    notifyProcessedOrdersLabel: 'ئاگادارکردنەوەی کڕیاران دەربارەی داواکارییە پرۆسەکراوەکان کە چاوەڕوانی ڕەزامەندین (بە کۆمەڵ دەنێردرێن)',
    hoursBeforeReminderLabel: 'کاتژمێر پێش ئاگادارکردنەوەی بیرخستنەوە',
    securitySectionDesc: 'دەسەڵاتی چوونەژوورەوە بۆ پەڕەی هەستیاری بەڕێوەبردن کۆنترۆڵ دەکات.',
    profileSectionDesc: 'چۆنیەتی دەستکاریکردنی پرۆفایلی کڕیار لە ئەپی مۆبایلەوە کۆنترۆڵ دەکات.',
    ordersSectionDesc: 'یاساکانی گۆڕینی دۆخ و دروستکردنی پسوڵە بۆ داواکارییەکان.',
    onlinePaymentSectionDesc: 'بەردەستبوونی FIB/QiCard/FastPay/ZainCash، و ئەو کۆمیسیۆنەی زیاد دەکرێت بۆ سەر بڕی کڕیار کاتێک باڵانس زیاد دەکات لە ڕێگەی FIB یان QI Card. هیچ کاتێک کۆمیسیۆن لەسەر پارەدانی داواکاری وەرناگیرێت.',
    staleOrdersSectionDesc: 'هەڵوەشاندنەوەی خۆکار بۆ داواکارییەکانی ماونەتەوە لە دۆخی داواکاری نوێ یان پرۆسەکراو، و ئاگادارکردنەوەی بیرخستنەوە بۆ داواکاری پرۆسەکراوەکان کە کڕیار پەسەندی نەکردووە.',
    fibCommissionRateHint: 'زیاد دەکرێت بۆ سەر بڕەکە کاتێک کڕیار باڵانس زیاد دەکات لە ڕێگەی FIB. کاریگەری نییە لەسەر پارەدانی داواکاری.',
    qiCommissionRateHint: 'زیاد دەکرێت بۆ سەر بڕەکە کاتێک کڕیار باڵانس زیاد دەکات لە ڕێگەی QI Card. کاریگەری نییە لەسەر پارەدانی داواکاری.',
    hoursBeforeAutoCancelHint: 'ئەو ماوەیەی داواکاری دەتوانێت لە دۆخی داواکاری نوێ یان پرۆسەکراو بمێنێتەوە پێش ئەوەی خۆکارانە هەڵبوەشێتەوە.',
    hoursBeforeReminderHint: 'ئەو ماوەیەی داواکاری پرۆسەکراو دەتوانێت چاوەڕوانی پەسەندکردنی کڕیار بکات پێش ناردنی ئاگادارکردنەوەی بیرخستنەوە.',
    settingsUpdatedSuccessfully: 'ڕێکخستنەکان بە سەرکەوتوویی نوێکرانەوە',
    pleaseUpdateAnything: 'تکایە شتێک نوێبکەرەوە',
    citiesTitle: 'شارەکان',
    governoratesTitle: 'پارێزگاکان',
    cancellationRefundReasonsTitle: 'هۆکارەکانی هەڵوەشاندنەوە و گەڕاندنەوە',
    deleteSubscriptionTooltip: 'سڕینەوەی بەشداریکردن',
    subscriptionPricingTitle: 'نرخنانی بەشداریکردن',
    pleaseSelectAtLeastOneUserSubscriptionToDelete: 'تکایە بۆ لانیکەم یەک بەشداریکردنی بەکارهێنەر هەڵبژێرە بۆ سڕینەوە',
    editOrderTypeTooltip: 'دەستکاریکردنی جۆری داواکاری',
    deleteOrderTypeTooltip: 'سڕینەوەی جۆری داواکاری',
    deleteOrderTypeConfirm: 'سڕینەوەی جۆری داواکاری: {name}؟',
    savedTitle: 'پاشکەوتکرا'
  },
  customer: {
    myOrdersTitle: 'داواکارییەکانم',
    orderDetailTooltip: 'وردەکارییەکانی داواکاری',
    editOrderTooltip: 'دەستکاریکردنی داواکاری',
    addTrackNumberTooltip: 'زیادکردنی ژمارەی شوێنپێدان',
    archiveThisOrderTooltip: 'ئەرشیفکردنی ئەم داواکارییە',
    onceArchivedWarning: 'دوای ئەرشیفکردن، ناتوانیت ئەم داواکارییە بگەڕێنیتەوە بۆ ئەم قۆناغە!',
    archivedTitle: 'ئەرشیفکرا',
    orderCanceledLabel: 'داواکاری هەڵوەشێنراوە:',
    refundReason: 'هۆکاری گەڕاندنەوە',
    processNote: 'تێبینی پرۆسەکردن',
    processNoteImage: 'وێنەی تێبینی پرۆسەکردن',
    trackNo: 'ژمارەی شوێنپێدان',
    link: 'لینک',
    couponPercentage: 'ڕێژەی کۆپۆن',
    color: 'ڕەنگ',
    deliveryType: 'جۆری گەیاندن',
    deliveryTypeUpdatedSuccessfully: 'جۆری گەیاندن بە سەرکەوتوویی نوێکرایەوە',
    repackage: 'دووبارە بەستنەوە',
    hold: 'ڕاگرتن',
    otherService: 'خزمەتگوزاری تر',
    quantityCharge: 'کرێی بڕ',
    itemPrice: 'نرخی کاڵا',
    internationalTax: 'باجی نێودەوڵەتی',
    itemType: 'جۆری کاڵا',
    addItemTypeTitle: 'زیادکردنی جۆری کاڵا',
    itemAddedSuccessfully: 'کاڵا بە سەرکەوتوویی زیادکرا',
    shippingPrice: 'نرخی گەیاندن',
    discountedShippingPrice: 'نرخی گەیاندن دوای داشکاندن',
    insurance: 'بیمە',
    repackagePrice: 'نرخی دووبارە بەستنەوە',
    holdPrice: 'نرخی ڕاگرتن',
    otherServicePrice: 'نرخی خزمەتگوزاری تر',
    handlingFee: 'کرێی جێبەجێکردن',
    itemWeightLb: 'کێشی کاڵا (پاوەند)',
    archivedOrdersTitle: 'داواکارییە ئەرشیفکراوەکان',
    orderDate: 'بەرواری داواکاری',
    otherServiceSpecify: 'خزمەتگوزاری تر (تکایە دیاری بکە)',
    couponCodeValidation: 'ئەم خانەیە دەبێت کۆدی کۆپۆنی تێدابێت',
    amountInIqdIs: 'بڕی پارە بە دیناری عێراقی بریتیە لە:',
    scanThisQrCode: 'ئەم کۆدی QR بسکانە',
    payWithLabel: 'پارەدان بە',
    minimumAmountHint: 'کەمترین بڕ ($0.2) یان (٢٥٠ دیناری عێراقی)',
    nextButton: 'دواتر',
    enterCodeManuallyHint: 'یان ئەم کۆدە بە دەستی بنووسە',
    tryAgainButton: 'دووبارە هەوڵبدەرەوە',
    chargeYourAccount: 'هەژمارەکەت پڕبکەرەوە',
    selectPaymentMethod: 'شێوازی پارەدان هەڵبژێرە',
    qiPaymentChecking: 'پارەدانەکەت لە ڕێگەی کی دەپشکنرێت…',
    qiPaymentSuccess: 'پارەکە وەرگیرا — باڵانسەکەت نوێکرایەوە.',
    qiPaymentPending: 'پارەدانەکەت لە ڕێگەی کی هێشتا لە پرۆسەدایە. باڵانسەکەت دوای پشتڕاستکردنەوە خۆکارانە نوێ دەبێتەوە.',
    qiPaymentCancelled: 'پارەدانی کی هەڵوەشێنرایەوە. هیچ پارەیەک نەبڕدرا.',
    qiPaymentFailed: 'پارەدانی کی سەرکەوتوو نەبوو. تکایە دووبارە هەوڵ بدەرەوە یان ڕێگایەکی تری پارەدان هەڵبژێرە.',
    cancelOrderTitle: 'هەڵوەشاندنەوەی داواکاری',
    cancelReasonLabel: 'هۆکاری هەڵوەشاندنەوە',
    deliverBranchLabel: 'لقی گەیاندن',
    approvedTitle: 'ڕەزامەندی درا',
    addAddressTitle: 'زیادکردنی ناونیشان',
    addTrackNumberTitle: 'زیادکردنی ژمارەی شوێنپێدان',
    trackNumberAddedSuccessfully: 'ژمارەی شوێنپێدان بە سەرکەوتوویی زیادکرا',
    checkRateTitle: 'پشکنینی نرخ',
    originCountry: 'وڵاتی سەرچاوە',
    weightPerPackage: 'کێش بۆ هەر پاکێج',
    length: 'درێژی',
    width: 'پانی',
    height: 'بەرزی',
    destinationCountry: 'وڵاتی مەبەست',
    documentOption: 'بەڵگەنامە',
    noneDocumentOption: 'بەڵگەنامە نییە',
    showRateButton: 'نرخ پیشان بدە',
    invoicesTitle: 'وەسڵەکان',
    partialRefundInvoiceTitle: 'وەسڵی گەڕاندنەوەی بەشێک',
    invoiceDate: 'بەرواری وەسڵ',
    description: 'وردەکاری',
    exportOrdersTitle: 'داواکارییەکانی هەناردەکردن',
    exportOrderDetailTitle: 'وردەکارییەکانی داواکاری هەناردەکردن',
    orderInfoSection: 'زانیاری داواکاری',
    priceInfoSection: 'زانیاری نرخ',
    delivery: 'گەیاندن',
    statusInfoSection: 'زانیاری دۆخ',
    orderedAt: 'بەرواری داواکاری',
    canceledAt: 'بەرواری هەڵوەشاندنەوە',
    canceledBy: 'هەڵوەشێنرایەوە لەلایەن',
    approvedAt: 'بەرواری ڕەزامەندی',
    approvedBy: 'ڕەزامەندی درا لەلایەن',
    refundedAt: 'بەرواری گەڕاندنەوە',
    refundedBy: 'گەڕێندرایەوە لەلایەن',
    sentAt: 'بەرواری ناردن',
    receivedAt: 'بەرواری وەرگرتن',
    receivedBy: 'وەرگیرا لەلایەن',
    receiverInfoSection: 'زانیاری وەرگر',
    zipCode: 'کۆدی پۆستە',
    productDescription: 'وردەکاری بەرهەم',
    receiverDetail: 'وردەکارییەکانی وەرگر',
    destination: 'مەبەست',
    updateExportOrderTitle: 'نوێکردنەوەی داواکاری هەناردەکردن',
    addExportOrderTitle: 'زیادکردنی داواکاری هەناردەکردن',
    requestExportOrderTitle: 'داواکاری هەناردەکردن',
    updateExportOrderTitleWithNumber: 'نوێکردنەوەی داواکاری هەناردەکردن {number}',
    requestedSuccessfullyMessage: 'بە سەرکەوتوویی داواکرا',
    requestButton: 'داواکردن',
    updateOrderTitleWithNumber: 'نوێکردنەوەی داواکاری {number}',
    requestOrderTitle: 'داواکاری نوێ',
    dimensionsPerPackageLabel: 'قەبارە بۆ هەر پاکێج',
    cancelNote: 'تێبینی هەڵوەشاندنەوە',
    approveOrderTooltip: 'ڕەزامەندی لەسەر داواکاری',
    volumeL: 'قەبارە (درێژی)',
    volumeW: 'قەبارە (پانی)',
    volumeH: 'قەبارە (بەرزی)',
    fullyRefundedBadge: 'بە تەواوی گەڕایەوە',
    partiallyRefundedBadge: 'بەشێکی گەڕایەوە',
    partiallyRefundedAt: 'کاتی گەڕاندنەوەی بەشی',
    partiallyRefundedBy: 'گەڕاندنەوەی بەشی لەلایەن',
    totalRefundedAmount: 'کۆی بڕی گەڕاوە',
    addingBalanceWithMethod: 'زیادکردنی باڵانس بە {method}',
    addingBalanceFromOffice: 'زیادکردنی باڵانس لە نووسینگەی شیپ زۆن',
    returningBalanceFromOffice: 'گەڕاندنەوەی باڵانس لە نووسینگەی شیپ زۆن',
    totalAddLabel: 'کۆی زیادکراو',
    totalCashBackLabel: 'کۆی گەڕاوە',
    generalTotalLabel: 'کۆی گشتی',
    totalSubLabel: 'کۆی کەمکراوە',
    totalRefundLabel: 'کۆی گەڕاوە',
    orderNoHeading: 'ژمارەی داواکاری {id}',
    expectedDateLabel: 'بەرواری چاوەڕوانکراو',
    requestedStepLabel: 'داواکراوە',
    deliveryStatusPrefix: 'گەیاندن {status}',
    cannotUpdateTrackNumber: 'ناتوانیت ژمارەی شوێنکەوتن نوێ بکەیتەوە',
    addressIsRequired: 'ناونیشان پێویستە',
    orderRequestedSuccessfully: 'داواکاری بە سەرکەوتوویی داواکرا'
  },
  finance: {
    banksTitle: 'بانکەکان',
    addBankTitle: 'زیادکردنی بانک',
    updateBankTitle: 'نوێکردنەوەی بانک',
    bankAddedSuccessfully: 'بانک بە سەرکەوتوویی زیادکرا',
    bankUpdatedSuccessfully: 'بانک بە سەرکەوتوویی نوێکرایەوە',
    filterByBank: 'پاڵاوتن بەپێی بانک',
    filterByStatus: 'پاڵاوتن بەپێی دۆخ',
    filterByType: 'پاڵاوتن بەپێی جۆر',
    bankTransactionsTitle: 'مامەڵەکانی بانک',
    totalAmount: 'کۆی گشتی بڕ',
    transactionDetailTitle: 'وردەکاری مامەڵە',
    transactionInfoSection: 'زانیاری مامەڵە',
    classificationSection: 'دەستەبەندی',
    sourceInfoSection: 'زانیاری سەرچاوە',
    datesAndStaffSection: 'بەروار و ستاف',
    couldNotUpdateVerificationStatus: 'نەتوانرا دۆخی پشتڕاستکردنەوە نوێبکرێتەوە',
    pleaseSelectTransactionsToVerify: 'تکایە مامەڵەکان هەڵبژێرە بۆ پشتڕاستکردنەوە',
    verifySelectedTransactionsConfirm: 'پشتڕاستکردنەوەی {count} مامەڵەی هەڵبژێردراو؟',
    transactionsVerifiedSuccessfully: 'مامەڵەکان بە سەرکەوتوویی پشتڕاستکرانەوە',
    pleaseTryAgain: 'تکایە دووبارە هەوڵبدەوە',
    statusPaid: 'دراوە',
    statusUnpaid: 'نەدراوە',
    statusPending: 'چاوەڕوان',
    statusCancel: 'هەڵوەشێنراوە',
    statusRefunded: 'گەڕێندراوەتەوە',
    statusPartialRefunded: 'بەشێکی گەڕێندراوەتەوە',
    typeOrder: 'داواکاری',
    typeMoneyTransfer: 'گواستنەوەی پارە',
    typeExpense: 'خەرجی',
    typeCreditInvoice: 'پسوڵەی باڵانس',
    typeCashBack: 'گەڕانەوەی نەقد',
    typeDigitalPayment: 'پارەدانی دیجیتاڵ',
    exchangeRatesTitle: 'نرخی ئاڵوگۆڕ',
    addExchangeRateTitle: 'زیادکردنی نرخی ئاڵوگۆڕ',
    updateExchangeRateTitle: 'نوێکردنەوەی نرخی ئاڵوگۆڕ',
    exchangeRateAddedSuccessfully: 'نرخی ئاڵوگۆڕ بە سەرکەوتوویی زیادکرا',
    exchangeRateUpdatedSuccessfully: 'نرخی ئاڵوگۆڕ بە سەرکەوتوویی نوێکرایەوە',
    currencyRatesTitle: 'نرخی دراوەکان',
    addCurrencyRateTitle: 'زیادکردنی نرخی دراوی نوێ',
    updateCurrencyRateTitle: 'نوێکردنەوەی نرخی دراو',
    sellRateLabel: 'نرخی فرۆشتنی {code} ({code} بۆ هەر 1 دۆلار)',
    buyRateLabel: 'نرخی کڕینی {code} (نرخی بانک)',
    expensesTitle: 'خەرجییەکان',
    addExpenseTitle: 'زیادکردنی خەرجی نوێ',
    updateExpenseTitle: 'نوێکردنەوەی خەرجی',
    thereIsAnError: 'هەڵەیەک هەیە',
    expenseFooterNote: 'هەر ڕیزێک دۆخێکی خەرجییە (کۆی <strong>هەموو</strong> ڕیزە هاوتاکان، هەموو پەڕەکان). خشتەی سەرەوە تەنها پەڕەی ئێستایە — لاپەڕەکردن بەکاربهێنە یان "بۆ هەر پەڕەیەک" بەرزبکەرەوە بۆ بینینی ڕیزەکانی نەدراو/نەقد. دراو + نەدراو + نەقد کۆبکەرەوە بۆ گونجاندن لەگەڵ "خەرجییەکان" لە سەرمایە کاتێک ماوەی بەروار لەگەڵ ماوەی پەڕتووکی سەرمایە یەکدەگرێتەوە.',
    received: 'وەرگیراوە',
    notReceived: 'وەرنەگیراوە',
    pleaseSelectAtLeastOneExpense: 'تکایە بەلایەنی کەم یەک خەرجی هەڵبژێرە!',
    markAllSelectedExpensesReceivedConfirm: 'ئەمە هەموو خەرجییە هەڵبژێردراوەکان وەک وەرگیراو نیشان دەدات.',
    somethingWentWrong: 'هەڵەیەک ڕوویدا!',
    supplierInvoiceNumberLabel: 'ژمارەی وەسڵی دابینکەر',
    expenseTypesTitle: 'جۆرەکانی خەرجی',
    addExpenseTypeTitle: 'زیادکردنی جۆری خەرجی نوێ',
    updateExpenseTypeTitle: 'نوێکردنەوەی جۆری خەرجی',
    capitalTitle: 'سەرمایە',
    refresh: 'نوێکردنەوە',
    initializeCapital: 'دەستپێکردنی سەرمایە',
    depositWithdraw: 'زیادکردن / لابردن',
    bookSummary: 'کورتەی دەفتەر ({from} بۆ {to})',
    initializedCapital: 'سەرمایەی دەستپێکراو',
    totalDeposits: 'کۆی زیادکراوەکان',
    totalWithdraws: 'کۆی لابراوەکان',
    revenueIncome: 'داهات (وەرگیراو)',
    netCapitalBook: 'پاکی سەرمایە (دەفتەر): {amount}',
    capitalMovements: 'جووڵەکانی سەرمایە',
    withdraw: 'لابردن',
    deposit: 'زیادکردن',
    saved: 'پاشکەوتکرا',
    couldNotSave: 'نەتوانرا پاشکەوت بکرێت',
    amountUsdLabel: 'بڕ (دۆلار) *',
    depositOrWithdrawTitle: 'زیادکردن یان لابردن',
    adjustsCapitalBookNote: 'تەنها دەفتەری سەرمایە ڕێکدەخات. باڵانسی بانکەکان لە سیستەمدا ناگۆڕدرێت.',
    noteOptionalLabel: 'تێبینی (ئارەزوومەندانە)',
    noteReasonPlaceholder: 'هۆکار یان سەرچاوە بۆ ئەم جووڵەیە',
    noteShownHint: 'ئەگەر دابنرێت، لە لیستی جووڵەکاندا دەردەکەوێت.',
    depositAddToCapitalBook: 'زیادکردن (زیادکردن بۆ دەفتەری سەرمایە)',
    withdrawSubtractFromCapitalBook: 'لابردن (کەمکردنەوە لە دەفتەری سەرمایە)',
    enterValidAmountError: 'بڕێکی دروست بنووسە (بەلایەنی کەم 0.01).',
    moneyTransfersTitle: 'گواستنەوەی پارە',
    transferMoneyTitle: 'گواستنەوەی پارە',
    doneSuccessfully: 'بە سەرکەوتوویی ئەنجامدرا'
  },
  login: {
    brandName: 'Las Shopping',
    welcomeBack: 'بەخێربێیتەوە!',
    signInToContinue: 'بچۆرە ژوورەوە بۆ بەردەوامبوون',
    phoneNumber: 'ژمارەی مۆبایل',
    password: 'وشەی نهێنی',
    loginButton: 'چوونەژوورەوە',
    noAccount: 'هەژمارت نییە؟',
    signUp: 'تۆمارکردن',
    adminLoginTitle: 'چوونەژوورەوەی بەڕێوەبەر',
    adminSignInSubtitle: 'بچۆرە ژوورەوە بۆ هەژماری ستاف',
    email: 'ئیمەیل'
  },
  signup: {
    createAccountTitle: 'دروستکردنی هەژمار',
    step1Hint: 'ژمارەی مۆبایلەکەت بنووسە بۆ وەرگرتنی کۆدی پشتڕاستکردنەوە.',
    sendCodeButton: 'ناردنی کۆد',
    alreadyHaveAccount: 'هەژمارت هەیە؟',
    signInLink: 'چوونەژوورەوە',
    otpSentHintPrefix: 'کۆدی پشتڕاستکردنەوە بنووسە کە نێردرا بۆ',
    verificationCodeLabel: 'کۆدی پشتڕاستکردنەوە',
    backButton: '← گەڕانەوە',
    verifyButton: 'پشتڕاستکردنەوە',
    step3Hint: 'پرۆفایلەکەت تەواو بکە بۆ تەواوکردنی خۆتۆمارکردن.',
    fullNameHint: 'بەلایەنی کەم ناوی یەکەم و دوایین بنووسە',
    dateOfBirthLabel: 'بەرواری لەدایکبوون',
    passwordMinCharsHint: 'کەمترین 6 پیت',
    emailOptionalLabel: 'ئیمەیل (ئارەزوومەندانە)',
    genderOptionalLabel: 'ڕەگەز (ئارەزوومەندانە)',
    maleOption: 'نێر',
    femaleOption: 'مێ',
    deliveryAddressOptional: 'ناونیشانی گەیاندن',
    optionalLabel: '(ئارەزوومەندانە)',
    addressSectionHint: 'یارمەتی خێراکردنی داواکارییەکانی داهاتوو دەدات',
    addressTypeLabel: 'جۆری ناونیشان',
    houseNumberLabel: 'ژمارەی ماڵ',
    floorOptionalLabel: 'نهۆم (ئارەزوومەندانە)',
    streetLabel: 'شەقام',
    buildingNameLabel: 'ناوی بینا',
    apartmentNumberLabel: 'ژمارەی شوقە',
    floorLabel: 'نهۆم',
    companyLabel: 'کۆمپانیا',
    addressPhoneNumberOptional: 'ژمارەی مۆبایلی ناونیشان (ئارەزوومەندانە)',
    additionalDirectionsOptional: 'ڕێنمایی زیاتر (ئارەزوومەندانە)',
    addressLabelHint: 'ناولێنانی ناونیشان (نموونە: ماڵ، کار)',
    createAccountButton: 'دروستکردنی هەژمار',
    houseType: 'ماڵ',
    apartmentType: 'شوقە',
    officeType: 'ئۆفیس',
    validPhoneRequiredError: 'تکایە ژمارەیەکی مۆبایلی دروست بنووسە',
    failedToSendCodeError: 'ناردنی کۆد سەرکەوتوو نەبوو',
    verificationCodeRequiredError: 'تکایە کۆدی پشتڕاستکردنەوە بنووسە',
    verificationFailedError: 'پشتڕاستکردنەوە سەرکەوتوو نەبوو',
    fullNameRequiredError: 'ناوی تەواو پێویستە',
    dobRequiredError: 'بەرواری لەدایکبوون پێویستە',
    passwordMinLengthError: 'وشەی نهێنی دەبێت بەلایەنی کەم 6 پیت بێت',
    confirmPasswordRequiredError: 'تکایە وشەی نهێنی دووپاتبکەرەوە',
    passwordsDoNotMatchError: 'وشە نهێنییەکان یەک ناگرنەوە',
    validEmailRequiredError: 'تکایە ئیمەیلێکی دروست بنووسە',
    addressTypeRequiredError: 'جۆری ناونیشان پێویستە',
    addressLabelRequiredError: 'ناولێنانی ناونیشان پێویستە (نموونە: ماڵ)',
    welcomeTitle: 'بەخێربێیت!',
    accountCreatedSuccessfully: 'هەژمارەکەت بە سەرکەوتوویی دروستکرا.',
    registrationFailedTitle: 'خۆتۆمارکردن سەرکەوتوو نەبوو',
    verifyAccountTitle: 'هەژمارەکەت پشتڕاست بکەرەوە',
    nextButton: 'دواتر',
    congratulationsTitle: 'پیرۆزە!',
    accountVerifiedSuccessfully: 'هەژمارەکەت بە سەرکەوتوویی پشتڕاست کرایەوە.',
    backToHomeButton: 'گەڕانەوە بۆ ماڵەوە'
  },
  statistics: {
    fromDateLabel: 'لە بەرواری',
    toDateLabel: 'بۆ بەرواری',
    chartTypeLabel: 'جۆری هێڵکار',
    barChartOption: 'هێڵکاری بار',
    pieChartOption: 'هێڵکاری بازنەیی',
    doughnutChartOption: 'هێڵکاری دۆناتی',
    lineChartOption: 'هێڵکاری هێڵی',
    applyButton: 'جێبەجێکردن',
    loadingStatisticsText: 'ئامارەکان باردەکرێن...',
    selectDateRangeHint: 'ماوەیەکی بەروار هەڵبژێرە و کرتە لە جێبەجێکردن بکە بۆ باردکردنی هێڵکارەکان.',
    noDataFoundHint: 'هیچ داتایەک نەدۆزرایەوە بۆ ماوەی بەرواری هەڵبژێردراو.',
    fullScreenTitle: 'شاشەی تەواو',
    topCustomersByOrderCount: 'باشترین 10 کڕیار بەپێی ژمارەی داواکاری',
    topCustomersByRevenue: 'باشترین 10 کڕیار بەپێی داهات ($)',
    revenueUsdLabel: 'داهات ($)',
    topWebsitesByOrders: 'باشترین 10 ماڵپەڕ بەپێی داواکاری',
    topWarehousesByOrders: 'باشترین 10 کۆگا بەپێی داواکاری',
    topProductsByOrders: 'باشترین 10 بەرهەم بەپێی داواکاری',
    topBrandsByOrders: 'باشترین 10 براند بەپێی داواکاری',
    orderStatusDistribution: 'دابەشکردنی دۆخی داواکاری',
    topItemTypesByOrders: 'باشترین 10 جۆری کاڵا بەپێی داواکاری',
    monthlyOrderTrend: 'ئاڕاستەی مانگانەی داواکاری',
    pleaseSelectFromToDate: 'تکایە بەرواری دەستپێک و کۆتایی هەڵبژێرە.',
    failedToLoadStatistics: 'باردکردنی ئامارەکان سەرکەوتوو نەبوو.'
  },
  linkRules: {
    updateLinkRuleTitle: 'نوێکردنەوەی یاسای لینک',
    addNewLinkRuleTitle: 'زیادکردنی یاسای لینکی نوێ',
    nameHint: "ناولێنانی بەڕێوەبەری، بۆ نموونە: 'Trendyol'",
    testUrlLabel: 'لینکی تاقیکردنەوە',
    testUrlHint: 'لینکی ڕاستەقینەی نموونەی بەرهەم لەم ماڵپەڕە بلکێنە. دۆمەین و پێشبینینی خوارەوە لێی وەردەگیرێت.',
    domainHint: 'وەک بەشێک لە دۆخی لینک دەگونجێت، بۆ نموونە: trendyol.com',
    shortLinkCheckboxLabel: 'ئەمە لینکێکی کورتە (ئاڕاستەکردنەوە، بۆ نموونە: ty.gl)',
    searchByNameOrDomainPlaceholder: 'گەڕان بە ناو یان دۆمەین...',
    shortLinkColumn: 'بەستەری کورت',
    priorityColumn: 'پێشینە',
    resolveButton: 'چارەسەرکردن',
    resolvesToLabel: 'دەگاتە:',
    detectedAsProductPage: '✅ وەک پەڕەی بەرهەم دۆزرایەوە',
    notDetectedAsProductPage: '❌ وەک پەڕەی بەرهەم نەدۆزرایەوە',
    previewExtractedNameLabel: 'پێشبینینی ناوی دەرهێنراو:',
    hideAdvancedOptions: 'شاردنەوەی هەڵبژاردنە پێشکەوتووەکان',
    advancedOptionsHint: 'هەڵبژاردنە پێشکەوتووەکان (تەنها پێویستە ئەگەر پێشبینینی سەرەوە هەڵە بێت)',
    productPageMatchTypeLabel: 'جۆری گونجانی پەڕەی بەرهەم',
    productPagePatternLabel: 'نموونەی پەڕەی بەرهەم',
    productPagePatternHint: 'بەشێک لە ڕێڕەو (لەخۆدەگرێت) یان ڕیجێکس',
    excludePathPrefixesLabel: 'پیشگرەکانی ڕێڕەوی دەرهێنراو',
    excludePathPrefixesHint: 'بە کۆما جیاکراوەتەوە، لیستی دەرهێنانی بنەڕەتی (سەبەتە/پارەدان/هتد) بۆ ئەم دۆمەینە دەگۆڕێت',
    nameExtractionTypeLabel: 'جۆری دەرهێنانی ناو',
    nameExtractionPatternLabel: 'نموونەی دەرهێنانی ناو',
    nameExtractionPatternHint: 'ڕیجێکس بە یەک گروپی گرتن، یان کلیلی پارامیتەری پرسیار',
    nameCleanupRegexLabel: 'ڕیجێکسی پاککردنەوەی ناو',
    nameCleanupRegexHint: 'ئارەزوومەندانە: لابەرێکی زیادەی دوایی کە دوای دەرهێنان جێبەجێدەکرێت',
    priorityLabel: 'پێشینە',
    priorityHint: 'کەمتر یەکەم جار جێبەجێدەکرێت کاتێک چەند یاسایەک دەتوانن بگونجێن',
    notesLabel: 'تێبینییەکان',
    containsPathSubstringOption: 'لەخۆدەگرێت (بەشێک لە ڕێڕەو)',
    regexOption: 'ڕیجێکس',
    regexCaptureGroupOption: 'ڕیجێکس (گروپی گرتنی 1)',
    queryParameterOption: 'پارامیتەری پرسیار',
    couldNotResolveUrl: 'نەتوانرا ئەم لینکە چارەسەر بکرێت'
  },
  qrLabels: {
    driverLabel: 'شۆفێر',
    productLabel: 'بەرهەم',
    printLabelDriverButton: 'چاپکردنی لەیبڵ (شۆفێر)',
    printLabelOrderIdButton: 'چاپکردنی لەیبڵ (ژمارەی داواکاری)',
    failedToGenerateQrCode: 'دروستکردنی کۆدی QR سەرکەوتوو نەبوو',
    failedToAdvanceToIntShipment: 'گواستنەوەی داواکارییەکان بۆ گەیاندنی نێودەوڵەتی سەرکەوتوو نەبوو'
  },
  datatable: {
    newOrderButton: 'داواکاری نوێ',
    reloadTableButton: 'نوێکردنەوەی خشتە',
    toggleButtonDisplayTooltip: 'پیشاندان/شاردنەوەی ناوی دوگمەکان',
    exportButton: 'هەناردەکردن',
    prepareToPrintButton: 'ئامادەکردن بۆ چاپکردن',
    fastPaymentButton: 'پارەدانی خێرا',
    mergeAndPrintButton: 'تێکەڵکردن و چاپکردن',
    receiveButton: 'وەرگرتن',
    unreceiveButton: 'هەڵوەشاندنەوەی وەرگرتن',
    printReceiveButton: 'چاپکردنی وەرگرتن',
    outOfficeButton: 'دەرەوەی نووسینگە',
    addNewButton: 'زیادکردنی نوێ',
    generateQrCodeButton: 'دروستکردنی کۆدی QR',
    generateInvoiceButton: 'دروستکردنی پسوڵە',
    attachToDeliveryButton: 'لکاندن بە گەیاندنەوە',
    changeStatusButton: 'گۆڕینی دۆخ',
    deliverySummaryButton: 'کورتەی گەیاندن',
    unclearButton: 'لابردنی پاڵاوتن',
    reloadShortLabel: 'نوێکردنەوە',
    qrCodeShortLabel: 'کۆدی QR',
    invoiceShortLabel: 'پسوڵە',
    statusShortLabel: 'دۆخ',
    summaryShortLabel: 'گەیاندن',
    prepareToPrintShortLabel: 'چاپکردن',
    fastPaymentShortLabel: 'پارەدانی خێرا',
    mergeAndPrintShortLabel: 'تێکەڵکردن',
    printReceiveShortLabel: 'چاپی وەرگرتن',
    sendAllToCustomerShortLabel: 'ناردنی هەموو',
    secondInvoiceShortLabel: 'پسوڵەی 2',
    generateSecondInvoiceButton: 'دروستکردنی پسوڵەی دووەم',
    deliveryInvoiceButton: 'پسوڵەی گەیاندن',
    sendToWarehouseButton: 'ناردن بۆ کۆگا',
    sendToPendingShipmentButton: 'ناردن بۆ گەیاندنی چاوەڕوان',
    sendAllToPendingShipmentButton: 'ناردنی هەموو بۆ گەیاندنی چاوەڕوان',
    sendToShipmentButton: 'ناردن بۆ گەیاندن',
    sendAllToShipmentButton: 'ناردنی هەموو بۆ گەیاندن',
    newShiponlyButton: 'تەنها گەیاندنی نوێ',
    sendToPendingToBranchButton: 'ناردن بۆ لق (چاوەڕوان)',
    sendToBranchButton: 'ناردن بۆ لق',
    sendAllToBranchButton: 'ناردنی هەموو بۆ لق',
    sendToBranchDeliveryButton: 'ناردن بۆ گەیاندنی لق',
    sendToCustomerButton: 'ناردن بۆ کڕیار',
    sendAllToCustomerButton: 'ناردنی هەموو بۆ کڕیار',
    addStaffButton: 'زیادکردنی ستاف',
    approveAllShiponlyButton: 'پەسندکردنی هەموو تەنها گەیاندن',
    bulkOrdersButton: 'داواکاری کۆمەڵ',
    sendAllToProcessButton: 'ناردنی هەموو بۆ پرۆسەکردن',
    cashBackButton: 'گەڕانەوەی نەقد',
    addCreditButton: 'زیادکردنی باڵانس',
    addWarehouseButton: 'زیادکردنی کۆگا',
    addCustomerButton: 'زیادکردنی کڕیار',
    generateCouponButton: 'دروستکردنی کوپۆن',
    addBankButton: 'زیادکردنی بانک',
    addSupplierButton: 'زیادکردنی دابینکەر',
    addExpenseTypeButton: 'زیادکردنی جۆری خەرجی',
    addNewExpenseButton: 'زیادکردنی خەرجی نوێ',
    addNewCityButton: 'زیادکردنی شاری نوێ',
    updateCityTitle: 'نوێکردنەوەی شار',
    updateAboutTitle: 'نوێکردنەوەی دەربارە',
    addNewAboutTitle: 'زیادکردنی دەربارەی نوێ',
    updateSupplierTitle: 'نوێکردنەوەی دابینکەر',
    addNewSupplierTitle: 'زیادکردنی دابینکەری نوێ',
    addGovernorateButton: 'زیادکردنی پارێزگا',
    addNewReasonButton: 'زیادکردنی هۆکاری نوێ',
    updateReasonTitle: 'نوێکردنەوەی هۆکار',
    addNewAboutAppButton: 'زیادکردنی زانیاری نوێی دەربارەی ئەپ',
    addNewHelpCenterButton: 'زیادکردنی ناوەندی یارمەتی نوێ',
    addNewRoleButton: 'زیادکردنی ڕۆڵی نوێ',
    updateRoleTitle: 'نوێکردنەوەی ڕۆڵ',
    deleteSelectedSubscriptionButton: 'سڕینەوەی بەشداری هەڵبژێردراو',
    addNewCustomerSubscriptionButton: 'زیادکردنی بەشداری کڕیاری نوێ',
    permanentlyDeleteSelectedOrdersButton: 'سڕینەوەی هەمیشەیی داواکارییە هەڵبژێردراوەکان',
    addNewBranchButton: 'زیادکردنی لقی نوێ',
    branchesTitle: 'لقەکان',
    updateBranchTitle: 'نوێکردنەوەی لق',
    addMoneyButtonDefault: 'زیادکردنی باڵانس',
    transferMoneyButton: 'گواستنەوەی پارە',
    addExchangeRateButton: 'زیادکردنی نرخی ئاڵوگۆڕ',
    requestDeliveryButton: 'داواکردنی گەیاندن',
    applyFilterTooltip: 'جێبەجێکردنی پاڵاوتن',
    cancelFilterTooltip: 'هەڵوەشاندنەوەی پاڵاوتن',
    showHideColumnsLabel: 'پیشاندان/شاردنەوەی ستوونەکان',
    pleaseSelectWarehouseHint: 'تکایە کۆگا هەڵبژێرە',
    pleaseSelectBothDatesError: 'تکایە هەردوو بەروار هەڵبژێرە!',
    chooseOption: 'هەڵبژێرە',
    orderOption: 'داواکاری',
    usaOption: 'ئەمریکا',
    chinaOption: 'چین',
    uaeOption: 'ئیمارات',
    partialReceivedOption: 'بەشێکی وەرگیراو'
  },
  printLogs: {
    title: 'تۆماری چاپکردن',
    subtitle: 'شوێنکەوتنی هەموو پسوڵە چاپکراوەکان',
    printButton: 'چاپکردن',
    printAllButton: 'چاپکردنی هەموو',
    fromLabel: 'لە',
    toLabel: 'بۆ',
    typeLabel: 'جۆر',
    allTypesOption: 'هەموو جۆرەکان',
    secondShippingOption: 'گەیاندنی دووەم',
    printedByLabel: 'چاپکراوە لەلایەن',
    allStaffOption: 'هەموو ستافەکان',
    filterButton: 'پاڵاوتن',
    todayButton: 'ئەمڕۆ',
    totalEntries: 'کۆی تۆمارەکان',
    totalAmountLabel: 'کۆی بڕ',
    firstPrints: 'چاپی یەکەم',
    reprints: 'دووبارە چاپکردن',
    loadingLogsText: 'تۆمارەکان باردەکرێن...',
    noPrintsFoundTitle: 'هیچ چاپێک نەدۆزرایەوە',
    noPrintsFoundBetween: 'هیچ پسوڵەیەک لە نێوان {from} و {to} چاپ نەکراوە.',
    timeColumn: 'کات',
    reprintBadge: 'دووبارە چاپکردن ×{count}',
    firstPrintBadge: 'چاپی یەکەم',
    viewOnlyBadge: 'تەنها بۆ بینین',
    viewOnlyTooltip: 'چاپکراوە لە دوگمەی بینینی پسوڵە — بەڵگە نییە بۆ پارەدان',
    deliveryPrintTooltip: 'چاپکراوە لە ڕێگەی دوگمەی گەیاندن — بەستراوەتەوە بە داواکاری گەیاندنی کڕیار',
    saveAndViewBadge: 'پاشکەوتکردن و بینین',
    saveAndViewTooltip: 'چاپکراوە لە ڕێگەی پاشکەوتکردن و بینین — کۆپیایەکی فەرمی لە پسوڵەی پاشکەوتکراو',
    totalLabel: 'کۆی گشتی',
    printPageTitle: 'تۆماری چاپکردن — {from} بۆ {to}'
  },
  profit: {
    title: 'قازانج',
    totalInternationalShipment: 'کۆی گەیاندنی نێودەوڵەتی',
    totalShippingInvoiceShipment: 'کۆی گەیاندنی پسوڵەی گەیاندن',
    totalLocalTax: 'کۆی باجی ناوخۆیی',
    totalFee: 'کۆی کرێ',
    totalRefund: 'کۆی گەڕاندنەوە',
    totalIncome: 'کۆی داهات',
    totalExpense: 'کۆی خەرجی'
  },
  driverDeliver: {
    loadingOrderDetails: 'وردەکارییەکانی داواکاری باردەکرێت...',
    orderMovedTitle: 'داواکاری گواسترایەوە بۆ گەیاندنی لق!',
    orderMovedMessage: 'داواکاری ژمارە {id} گواسترایەوە بۆ گەیاندنی لق.',
    alreadyAtBranchTitle: 'پێشتر لە لقەکەیە',
    alreadyAtBranchMessage: 'ئەم داواکارییە پێشتر گواسترایەوە بۆ گەیاندنی لق.',
    cannotProcessTitle: 'ناتوانرێت پرۆسەبکرێت',
    wrongStatusMessage: 'ئەم داواکارییە لە قۆناغی گەیاندنی نێودەوڵەتی نییە. باری ئێستا:',
    orderNumberLabel: 'داواکاری ژمارە {id}',
    naLabel: 'بەردەست نییە',
    areaLabel: 'ناوچە',
    houseBuildingLabel: 'ماڵ / بینا',
    deliveryPhoneLabel: 'تەلەفۆنی گەیاندن',
    tapToMoveButton: 'دەست لێبدە بۆ گواستنەوە بۆ گەیاندنی لق',
    processingButton: 'پرۆسەکردن...',
    unknownStatus: 'نەزانراو',
    failedToLoadOrder: 'باردکردنی داواکاری سەرکەوتوو نەبوو',
    failedToLoadOrderDetails: 'باردکردنی وردەکارییەکانی داواکاری سەرکەوتوو نەبوو',
    failedToProcessOrder: 'پرۆسەکردنی داواکاری سەرکەوتوو نەبوو'
  },
  addEditGovernorate: {
    updateTitle: 'نوێکردنەوەی پارێزگا',
    addTitle: 'زیادکردنی پارێزگای نوێ',
    governorateNameLabel: 'ناوی پارێزگا',
    governorateNameArLabel: 'ناوی پارێزگا (عەرەبی)',
    governorateNameKuLabel: 'ناوی پارێزگا (کوردی)'
  },
  cashBack: {
    title: 'گەڕاندنەوەی پارەی کرێدیت',
    cashedBackSuccessfully: 'کرێدیت بە سەرکەوتوویی وەک پارە گەڕایەوە',
    amountMoreThanCreditError: 'بڕی گەڕاندنەوە زیاترە لە کرێدیتی کڕیار',
    editTitle: 'دەستکاریکردنی گەڕاندنەوەی پارە',
    updatedSuccessfully: 'گەڕاندنەوەی پارە بە سەرکەوتوویی نوێکرایەوە'
  },
  generateCoupon: {
    couponsGeneratedSuccessfully: 'کوپۆنەکان بە سەرکەوتوویی دروستکران',
    couponsUpdatedSuccessfully: 'کوپۆنەکان بە سەرکەوتوویی نوێکرانەوە',
    numberOfCouponLabel: 'ژمارەی کوپۆن',
    discountPercentageLabel: 'ڕێژەی داشکاندن',
    expireDateLabel: 'بەرواری بەسەرچوون',
    generateButton: 'دروستکردن',
    pleaseDetermineExpireDate: 'تکایە بەرواری بەسەرچوون دیاری بکە',
    expireDateMustBeGreaterThanToday: 'بەرواری بەسەرچوون دەبێت لە ئەمڕۆ زیاتر بێت'
  },
  partialRefundingOrder: {
    title: 'گەڕاندنەوەی بەشی',
    orderTotalAmountLabel: 'کۆی گشتی داواکاری ${amount}ە'
  },
  addEditOrderCase: {
    updateTitle: 'نوێکردنەوەی کەیسی داواکاری',
    addTitle: 'زیادکردنی کەیسی داواکاری نوێ',
    orderIdColon: 'ناسنامەی داواکاری:',
    imagesTitle: 'وێنەکانی کەیسی داواکاری'
  },
  addEditNotFoundOrder: {
    updateTitle: 'نوێکردنەوەی داواکاری نەدۆزراوە',
    addTitle: 'زیادکردنی داواکاری نەدۆزراوەی نوێ',
    updatedTitle: 'نوێکرایەوە'
  },
  adminCancelOrder: {
    orderCanceledSuccessfully: 'داواکاری بە سەرکەوتوویی هەڵوەشێندرایەوە',
    willAutoRefundPrefix: 'ئەم داواکارییە پێشتر کڕدراوە. هەڵوەشاندنەوەی بەشێوەیەکی خۆکار گەڕاندنەوەیەکی تەواو دەردەکات',
    ofUpToAmount: ' هەتا ${amount}',
    willAutoRefundTail: ' بۆ باڵانسی کرێدیتی کڕیار. بڕی ورد هەموو گەڕاندنەوەی بەشی پێشووتر لەبەرچاو دەگرێت.',
    cancelReasonListLabel: 'لیستی هۆکاری هەڵوەشاندنەوە',
    cancelReasonEnglishLabel: 'هۆکاری هەڵوەشاندنەوە بە ئینگلیزی',
    cancelReasonArabicLabel: 'هۆکاری هەڵوەشاندنەوە بە عەرەبی',
    cancelReasonKurdishLabel: 'هۆکاری هەڵوەشاندنەوە بە کوردی'
  },
  globalWebsiteGroupModal: {
    updateGroupTitle: 'نوێکردنەوەی گروپ',
    addNewGroupTitle: 'زیادکردنی گروپی نوێ',
    sitesButton: 'ماڵپەڕەکان'
  },
  recordInvoicePayment: {
    title: 'تۆمارکردنی پارەدان',
    invoiceHashLabel: 'ژمارەی پسوڵە #',
    walletBalanceCheckboxLabel: 'کڕیار پێشتر ئەم بڕەی لە باڵانسی کیفەکەیدا هەیە (بۆ نموونە لە پڕکردنەوەی FIB/QI/ئۆفیس) — بەبێ زیادکردنی کرێدیتێکی نوێ جێبەجێی بکە',
    balanceOption: 'باڵانس',
    availableTitle: 'ئەم کڕیارە {amount} باڵانسی بەردەستی هەیە',
    useBalance: 'باڵانس بەکاربهێنە',
    unknownSource: 'سەرچاوە دیاری نەکراوە',
    balanceHint: '"باڵانس" هەرگیز پارە زیاد ناکات — لەو پارەیە دەدات کە کڕیار پێشتر هەیەتی.',
    balanceButton: 'باڵانس',
    payButton: 'پارەدان'
  },
  addEditUserSubscription: {
    customerSubscriptionTitle: 'بەشداریی کڕیار',
    deleteAllSelectedConfirm: 'هەموو بەشداریی بەکارهێنەرە هەڵبژێردراوەکان بسڕدرێتەوە؟'
  },
  orderDeliveryCustomerImages: {
    title: 'داواکاری و وێنەکانی کڕیار',
    noOrdersFound: 'هیچ داواکارییەک بۆ ئەم کڕیارە نەدۆزرایەوە.',
    productLabel: 'بەرهەم',
    imagesLabel: 'وێنەکان',
    notInvoiced: 'پسوڵەی نییە'
  },
  viewOrderDates: {
    pendingAnswerDateLabel: 'ڕۆژی چاوەڕوانی وەڵام',
    processDateLabel: 'ڕۆژی پرۆسەکردن',
    cancelDateLabel: 'ڕۆژی هەڵوەشاندنەوە',
    approveDateLabel: 'ڕۆژی پەسندکردن',
    refundDateLabel: 'ڕۆژی گەڕاندنەوە',
    pendingShipmentDateLabel: 'ڕۆژی چاوەڕوانی گەیاندن',
    shipmentDateLabel: 'ڕۆژی گەیاندن',
    deliveredDateLabel: 'ڕۆژی گەیشتن'
  },
  refundingOrder: {
    title: 'گەڕاندنەوەی داواکاری',
    sendSmsLabel: 'ناردنی SMS',
    orderTotalRemainAmountLabel: 'کۆی بڕی ماوەی داواکاری ${amount}ە'
  },
  assignPermission: {
    titleWithRole: 'دیاریکردنی مۆڵەت بۆ ڕۆڵی [{role}]',
    savedSuccessfully: 'بە سەرکەوتوویی پاشکەوتکرا',
    checkAllLabel: 'هەموو هەڵبژێرە'
  },
  purchaseOrder: {
    titleWithId: 'کڕینی داواکاری {id}',
    costBreakdownByWarehouse: 'وردەکاری تێچوون بەپێی کۆگا',
    ordersSelectedLabel: '{count} داواکاری هەڵبژێردراوە',
    actualPriceLabel: 'نرخی ڕاستەقینە',
    actualPriceRequiredError: 'نرخی ڕاستەقینە پێویستە',
    mustBeValidNumberError: 'دەبێت ژمارەیەکی دروست بێت'
  },
  reassignCustomer: {
    reassignCustomerTooltip: 'گۆڕینی کڕیار',
    chargedToLabel: 'ئەم داواکارییە ئێستا نرخی لەسەر',
    pickingDifferentCustomerText: 'هەڵبژاردنی کڕیارێکی جیاواز لە خوارەوە {name} دەگەڕێنێتەوە، پسوڵەی گەیاندنی ئەم داواکارییە دەسڕێتەوە، و کڕیاری هەڵبژێردراو بە پسوڵەیەکی نوێ بە هەمان بڕ (${amount}) نرخی لەسەر دادەنرێت.',
    newCustomerLabel: 'کڕیاری نوێ* (گەڕان بە ناو یان ژمارەی تەلەفۆن)',
    telPrefix: ' - تەلەفۆن: ',
    failedToLoadCustomers: 'باردکردنی کڕیارەکان سەرکەوتوو نەبوو',
    selectedCustomerFallback: 'کڕیارە هەڵبژێردراوەکە',
    confirmReassignText: 'ئەمە {name} دەگەڕێنێتەوە، پسوڵەی گەیاندنی ئەم داواکارییە دەسڕێتەوە، و {newName} بە پسوڵەیەکی نوێ بە بڕی ${amount} نرخی لەسەر دادەنرێت. بەردەوامبیت؟',
    failedToReassignCustomer: 'گۆڕینی کڕیار سەرکەوتوو نەبوو'
  },
  createCredit: {
    creditAddedSuccessfully: 'کرێدیت بە سەرکەوتوویی زیادکرا',
    amountUsdLabel: 'بڕی دۆلار',
    amountIqdLabel: 'بڕی دینار',
    autoInvoiceLabel: 'بە خۆکاری پسوڵە دروستبکە بۆ داواکاری گەیەندراو کە هێشتا پسوڵەی نییە (لابردنی هەڵبژاردن تەنها دروستکردنی پسوڵەیەکی نوێ لادەبات — ئەم پڕکردنەوەیە هەر هەموو پسوڵەیەکی هەبوو دەیدات)'
  },
  helpCenter: {
    updateTitle: 'نوێکردنەوەی ناوەندی یارمەتی',
    questionEnLabel: 'پرسیار (ئینگلیزی)',
    questionArLabel: 'پرسیار (عەرەبی)',
    questionKuLabel: 'پرسیار (کوردی)',
    answerEnLabel: 'وەڵام (ئینگلیزی)',
    answerArLabel: 'وەڵام (عەرەبی)',
    answerKuLabel: 'وەڵام (کوردی)',
    isActiveLabel: 'چالاکە',
    answerEnRequiredError: 'وەڵام (ئینگلیزی) پێویستە',
    displayLanguageLabel: 'زمانی نیشاندان',
    englishEnOption: 'ئینگلیزی (en)',
    arabicArOption: 'عەرەبی (ar)',
    kurdishKuOption: 'کوردی (ku)'
  },
  processExportOrder: {
    title: 'پرۆسەکردنی داواکاری هەناردەکردن',
    orderNoColon: 'ژمارەی داواکاری:'
  },
  customerDeliverySummary: {
    title: 'کورتەی گەیاندنی کڕیار',
    clearButton: 'پاککردنەوە',
    loadingAllOrders: 'هەموو داواکارییە هاوتاکان باردەکرێن…',
    totalCustomerLabel: 'کۆی کڕیار',
    totalOrdersLabel: 'کۆی داواکاری',
    requestReceivedLabel: 'داواکاری وەرگیراو',
    dateReceivedLabel: 'ڕۆژی وەرگرتن',
    timeLabel: 'کات',
    confirmClearOrdersText: 'نیشانەکردنی {count} داواکاری وەک پاککراوە؟ چیتر بە شێوازی بنەڕەتی لەم لیستەدا دەرناکەوێت.',
    failedToClearOrders: 'پاککردنەوەی داواکارییەکان سەرکەوتوو نەبوو'
  },
  adminDashboard: {
    title: 'داشبۆرد',
    updatedAtLabel: 'نوێکراوەتەوە {time}',
    refreshButton: 'نوێکردنەوە',
    loadingDashboardText: 'داشبۆرد باردەکرێت...',
    orderIntakeSection: 'وەرگرتنی داواکاری',
    processingSection: 'پرۆسەکردن',
    fulfillmentSection: 'جێبەجێکردن',
    deliveryCompletionSection: 'گەیاندن و تەواوکردن',
    pendingAnswerLabel: 'چاوەڕوانی وەڵام',
    processedLabel: 'پرۆسەکراوە',
    ordersTodayLabel: 'داواکاریی ئەمڕۆ',
    pendingPaymentsLabel: 'پارەدانی چاوەڕوان',
    purchasedLabel: 'کڕدراوە',
    warehouseDeliveredLabel: 'گەیشتووەتە کۆگا',
    intShipmentLabel: 'گەیاندنی نێودەوڵەتی',
    pendingToBranchLabel: 'چاوەڕوانی گواستنەوە بۆ لق',
    branchDeliveryLabel: 'گەیاندنی لق',
    deliveredLabel: 'گەیەندراوە',
    kurdistanBalance: 'باڵانسی کوردستان',
    usaBalance: 'باڵانسی ئەمریکا',
    customersOweUs: 'کڕیارەکان قەرزارمانن',
    weOweCustomers: 'ئێمە قەرزاری کڕیارەکانین',
    supplierLoan: 'قەرزی دابینکەر',
    totalCapital: 'کۆی سەرمایە'
  },
  homeSlider: {
    updateTitle: 'نوێکردنەوەی سلایدەری سەرەکی',
    addTitle: 'زیادکردنی سلایدەری سەرەکی نوێ'
  },
  editOrderCharge: {
    editChargeTooltip: 'دەستکاری نرخ',
    editChargeTitle: 'دەستکاری نرخ',
    alreadyChargedHint: 'ئەم داواکارییە پێشتر نرخی بۆ دراوە. گۆڕینی کۆی خوارەوە بەشێوەیەکی خۆکار جیاوازییەکە لە باڵانسی کڕیار کەم یان زیاد دەکات.',
    itemPriceUsdLabel: 'نرخی کاڵا ($)',
    shippingUsdLabel: 'گەیاندن ($)',
    discountUsdLabel: 'داشکاندن ($)',
    newTotalLabel: 'کۆی نوێ:',
    wasLabel: '(پێشتر ${amount} بوو)',
    failedToLoadOrderDetails: 'باردکردنی وردەکارییەکانی داواکاری سەرکەوتوو نەبوو',
    increaseWithBalanceText: 'کۆی گشتی زیاد دەبێت لە ${from} بۆ ${to} (+${diff}). ${diff} لە باڵانسی کڕیار کەم دەکرێتەوە. بەردەوامبیت؟',
    increaseInsufficientBalanceText: 'کۆی گشتی زیاد دەبێت لە ${from} بۆ ${to} (+${diff}). لەوانەیە باڵانسی کڕیار ناتەواو بێت — لەبری ئەوە تێبینییەک تۆمار دەکرێت. بەردەوامبیت؟',
    decreaseText: 'کۆی گشتی کەم دەبێتەوە لە ${from} بۆ ${to} (-${diff}). ${diff} بۆ باڵانسی کڕیار زیاد دەکرێت. بەردەوامبیت؟',
    orderUpdatedTitle: 'داواکاری نوێکرایەوە',
    failedToUpdateOrder: 'نوێکردنەوەی داواکاری سەرکەوتوو نەبوو'
  },
  refundExportOrder: {
    fullRefundTitle: 'گەڕاندنەوەی تەواوی داواکاری هەناردەکردن',
    partialRefundTitle: 'گەڕاندنەوەی بەشی داواکاری هەناردەکردن',
    refundedSuccessfully: 'داواکاری بە سەرکەوتوویی گەڕایەوە',
    orderTotalAmountLabel: 'کۆی گشتی داواکاری ${amount}ە',
    alreadyRefundedLabel: 'پێشتر گەڕاوەتەوە: ${amount}',
    moneyAmountLabel: 'بڕی پارە',
    refundNoteLabel: 'تێبینی گەڕاندنەوە',
    confirmRefundText: 'ئەمە ${amount} دەگەڕێنێتەوە بۆ کرێدیتی کڕیار.',
    validRefundAmountError: 'تکایە بڕێکی دروست بۆ گەڕاندنەوە بنووسە',
    amountExceedsRemainingError: 'بڕەکە ناتوانێت زیاتر بێت لە بڕی ماوە: ${amount}',
    partialLessThanRemainingError: 'گەڕاندنەوەی بەشی دەبێت کەمتر بێت لە بڕی ماوە: ${amount}',
    refundReasonRequiredError: 'هۆکاری گەڕاندنەوە پێویستە بۆ گەڕاندنەوەی تەواو',
    fullRefundProcessedSuccessfully: 'گەڕاندنەوەی تەواو بە سەرکەوتوویی ئەنجامدرا',
    partialRefundProcessedSuccessfully: 'گەڕاندنەوەی بەشی بە سەرکەوتوویی ئەنجامدرا',
    failedToProcessRefund: 'ئەنجامدانی گەڕاندنەوە سەرکەوتوو نەبوو'
  },
  secret: {
    greetingHi: 'سڵاو {name}',
    enterSecretKeyHint: 'بۆ بینینی ئەم بەشە دەبێت کلیلی نهێنیت داخل بکەیت',
    dontHaveSecretKey: 'کلیلی نهێنیت نییە؟',
    letMeInButton: 'بمهێڵەرێ',
    confirmSecretKeyLabel: 'دووپاتکردنەوەی کلیلی نهێنی'
  },
  viewOrderUsers: {
    orderedBy: 'داواکراوە لەلایەن',
    shipOnlyBy: 'تەنها گەیاندن لەلایەن',
    pendingAnsweredBy: 'وەڵام دراوەتەوە لەلایەن',
    processedBy: 'پرۆسەکراوە لەلایەن',
    warehousedBy: 'خراوەتە کۆگاوە لەلایەن',
    pendingShippedBy: 'چاوەڕوانی گەیاندن لەلایەن',
    shippedBy: 'گەیەندراوە لەلایەن',
    pendingToBranchBy: 'چاوەڕوانی گواستنەوە بۆ لق لەلایەن',
    brandDeliveredBy: 'گەیشتووەتە لق لەلایەن',
    deliveredBy: 'گەیەندراوە لەلایەن',
    archivedBy: 'ئەرشیفکراوە لەلایەن'
  },
  home: {
    welcomeTitle: 'بەخێربێیت بۆ Lasshopping',
    pleaseFillOutInfo: 'تکایە ئەم زانیارییانە پڕبکەرەوە',
    processWasSuccessful: 'پرۆسەکە سەرکەوتوو بوو',
    realEmailHint: 'ئیمەیلەکە دەبێت ڕاستەقینە بێت، چونکە هەموو کردارەکانی سەر داواکارییەکەت بۆ ئەم ئیمەیلە دەنێردرێت'
  },
  forceUpdate: {
    updateTitle: 'نوێکردنەوەی زۆرەملێ',
    addTitle: 'زیادکردنی نوێکردنەوەی زۆرەملێی نوێ',
    minBuildNumberLabel: 'کەمترین ژمارەی بنیاتی پێویست',
    minBuildNumberHint: 'هەر ئەپێکی دامەزراو کە لەژێر ئەم ژمارە بنیاتەدایە زۆرەملێ دەکرێت نوێ بکرێتەوە.',
    operatingSystemLabel: 'سیستەمی کارپێکردن',
    imageMustBeImageError: 'جۆری فایل دەبێت وێنە بێت',
    minBuildNumberColumn: 'کەمترین ژمارەی بڵد',
    softUpdateType: 'نەرم',
    hardUpdateType: 'ڕەق'
  },
  editCredit: {
    title: 'دەستکاریکردنی باڵانس',
    updatedSuccessfully: 'باڵانس بە سەرکەوتوویی نوێکرایەوە'
  },
  addEditSubscription: {
    addTitle: 'زیادکردنی بەشداریکردن',
    addNewButton: 'زیادکردنی بەشداریکردنی نوێ',
    nameLabel: 'ناوی بەشداریکردن',
    deleteSubscriptionConfirm: 'بەشداریکردن بسڕدرێتەوە: {name}؟',
    deleteUserSubscriptionConfirm: 'بەشداریکردنی بەکارهێنەر بسڕدرێتەوە: {name}؟'
  },
  addEditOrderType: {
    addTitle: 'زیادکردنی جۆری داواکاری',
    nameLabel: 'ناوی جۆر',
    addNewButton: 'زیادکردنی جۆری داواکاری نوێ'
  },
  prepareToPrint: {
    arrivedDateLabel: 'ڕێکەوتی گەیشتن:',
    signatureLabel: 'واژۆ'
  },
  exportOrder: {
    cancelTitle: 'هەڵوەشاندنەوەی داواکاری هەناردەکردن'
  },
  editTransportationType: {
    title: 'دەستکاریکردنی جۆری گواستنەوە'
  },
  invoicePaymentLogs: {
    title: 'تۆمارەکانی پارەدان',
    paidAfterColumn: 'پارەدراو دوای',
    remainingAfterColumn: 'ماوە دوای',
    noPaymentsRecordedYet: 'هیچ پارەدانێک تۆمار نەکراوە'
  },
  editProductName: {
    title: 'دەستکاریکردنی ناوی بەرهەم',
    updatedSuccessfully: 'ناوی بەرهەم بە سەرکەوتوویی نوێکرایەوە'
  },
  sendToWarehouse: {
    title: 'ناردنی داواکاری بۆ کۆگا'
  },
  sendToShipment: {
    title: 'ناردنی داواکاری بۆ گەیاندن'
  },
  sendNotification: {
    title: 'ناردنی ئاگادارکردنەوە',
    sendToAllLabel: 'ناردن بۆ هەموو',
    sendToDeliveredLabel: 'ناردن بۆ کڕیارانی داواکاری گەیەندراو',
    selectCustomerLabel: 'کڕیار هەڵبژێرە',
    bodyLabel: 'ناوەڕۆک',
    historyTitle: 'پێشتر نێردراوە',
    historyEmptyLabel: 'هیچ ئاگادارکردنەوەیەک نەنێردراوە',
    useAgainTooltip: 'ئەم نامەیە بەکاربهێنە',
    audienceAllLabel: 'هەموو کڕیارەکان',
    audienceDeliveredOnlyLabel: 'کڕیارانی داواکاری گەیەندراو',
    audienceCustomSuffix: 'کڕیار',
    recipientsLabel: 'وەرگرەکان'
  },
  ourAddress: {
    searchPlaceholder: 'گەڕان...',
    transByColumn: 'شێوازی گواستنەوە',
    ourAddressesTitle: 'ناونیشانەکانمان'
  },
  homeBanner: {
    isCounterLabel: 'ژماردنەوەیە',
    titleArabicLabel: 'ناونیشان بە عەرەبی',
    titleKurdishLabel: 'ناونیشان بە کوردی',
    descriptionArabicLabel: 'وەسف بە عەرەبی',
    descriptionKurdishLabel: 'وەسف بە کوردی',
    startDateLabel: 'ڕێکەوتی دەستپێک',
    endDateLabel: 'ڕێکەوتی کۆتایی',
    colorDarkLabel: 'ڕەنگی تاریک',
    backgroundColorLabel: 'ڕەنگی پاشبنەما',
    backgroundColorDarkLabel: 'ڕەنگی پاشبنەمای تاریک',
    titleRequiredError: 'ناونیشان پێویستە',
    titleArabicRequiredError: 'ناونیشان بە عەرەبی پێویستە',
    titleKurdishRequiredError: 'ناونیشان بە کوردی پێویستە',
    startDateRequiredError: 'ڕێکەوتی دەستپێک پێویستە',
    endDateRequiredError: 'ڕێکەوتی کۆتایی پێویستە',
    endDateAfterStartDateError: 'ڕێکەوتی کۆتایی دەبێت دوای ڕێکەوتی دەستپێک بێت',
    colorHexError: 'ڕەنگ دەبێت کۆدی ڕەنگی هێکس دروست بێت',
    descriptionRequiredError: 'وەسف پێویستە',
    descriptionArabicRequiredError: 'وەسف بە عەرەبی پێویستە',
    descriptionKurdishRequiredError: 'وەسف بە کوردی پێویستە'
  },
  customerPrices: {
    updatedSuccessfully: 'نرخەکانی کڕیار بە سەرکەوتوویی نوێکرانەوە',
    baseQttChargeUsaLabel: 'باجی بڕی بنەڕەتی (ئەمریکا)',
    otherQttChargeUsaLabel: 'باجی بڕی دیکە (ئەمریکا)'
  },
  kreenexFeePrices: {
    updatedSuccessfully: 'نرخەکانی کرێی ShipZone بە سەرکەوتوویی نوێکرانەوە',
    feePercentageLabel: 'ڕێژەی کرێی ShipZone',
    feeBaseUsaLabel: 'بنەڕەتی کرێی ShipZone (ئەمریکا)',
    feeUsaLabel: 'کرێی ShipZone (ئەمریکا)',
    explanationInPrefix: 'لە',
    explanationIfLessThan: 'ئەگەر',
    explanationLessThan: 'کەمتر بێت لە',
    explanationWillBe: 'دەبێت بە',
    explanationOtherwise: '، ئەگینا',
    explanationFormula: 'کرێی ShipZone (ئەمریکا) + (نرخی کاڵا × ڕێژەی کرێی ShipZone)'
  },
  orderStatusSettings: {
    title: 'ڕێکخستنەکانی دۆخی داواکاری',
    description: 'ناوی هەر دۆخێکی داواکاری بگۆڕە، ڕەنگی بگۆڕە، یان بیشارەوە. دۆخی شاراوە لە هەڵبژاردنی دۆخ، پاڵاوتنەکان و ڕێنیشاندەری بەڕێوەبەری، ماڵپەڕی کڕیار و ئەپی مۆبایل نامێنێت — لۆجیکی دۆخی سەرەکی (گواستنەوەکان، گەڕاندنەوەکان، هتد) بەردەوام کار دەکات وەک خۆی.',
    displayNameEnColumn: 'ناوی نیشاندان (ئینگلیزی)',
    displayNameArColumn: 'ناوی نیشاندان (عەرەبی)',
    displayNameKuColumn: 'ناوی نیشاندان (کوردی)',
    displayNameTrColumn: 'ناوی نیشاندان (تورکی)',
    visibleColumn: 'دیارە',
    egNewOrderPlaceholder: 'وەک نموونە: داواکاری نوێ',
    failedToSaveOneOrMoreStatuses: 'پاشەکەوتکردنی یەک یان چەند دۆخێک سەرکەوتوو نەبوو'
  },
  changeOrderStatus: {
    title: 'گۆڕینی دۆخی داواکاری',
    ordersSelectedSuffix: 'داواکاری هەڵبژێردراوە',
    orderColonPrefix: 'داواکاری:',
    alreadyPurchasedBeforeInfo: 'ئەم داواکارییە پێشتر کڕدراوە — ڕاستەوخۆ دەگوازرێتەوە بۆ دۆخی کڕدراو، پێویست ناکات ئەم زانیارییانە دووبارە بنووسیتەوە.',
    actualPriceCalculatedAutomatically: 'نرخی ڕاستەقینە بۆ هەر داواکارییەک بە خۆکار دەژمێردرێت.',
    refundReasonRequiredLabel: 'هۆکاری گەڕاندنەوە*',
    moneyAmountLabel: 'بڕی پارە',
    eachOrderRefundedFullRemaining: 'هەموو بڕی ماوە بۆ هەر داواکارییەک دەگەڕێندرێتەوە.',
    savingLabel: 'پاشەکەوتکردن...',
    unmarkOrdersAsClearedConfirm: 'هەڵوەشاندنەوەی نیشانەی پاککراوە بۆ {count} داواکاری؟ دووبارە دەردەکەون لەم لیستەدا لەژێر پاڵاوتنی چالاک.',
    orderAlreadyHasInvoiceMessage: 'داواکاری {orderId} پێشتر پسوڵەیەکی {status}{invoiceNumber} هەیە. بەردەوامبوون کڕیار دووبارە پارە لێ ناسێنێت. بەردەوام بیت؟',
    ordersAlreadyHaveInvoiceMessage: 'ئەم داواکارییانە پێشتر پسوڵەی دراو یان بەشێکی دراویان هەیە:\n\n{lines}\n\nبەردەوامبوون دووبارە پارەیان لێ ناسێنێت. بەردەوام بیت؟',
    orderAlreadyPurchasedRefundWarning: 'ئەم داواکارییە پێشتر کڕدراوە/گەیەندراوە. هەڵوەشاندنەوەی خۆکارانە گەڕاندنەوەیەکی تەواو دەکاتەوە تا ${amount} بۆ کڕیار.',
    statusLockedOrderCanceled: 'دۆخ قفڵکراوە — داواکاری هەڵوەشێنراوەتەوە',
    clickToChangeStatus: 'کلیک بکە بۆ گۆڕینی دۆخ',
    failedToChangeOrderStatus: 'گۆڕینی دۆخی داواکاری سەرکەوتوو نەبوو',
    ordersUpdatedSuccessfully: 'داواکارییەکان بە سەرکەوتوویی نوێکرانەوە'
  },
  shipOnly: {
    orderNoteColumn: 'تێبینی داواکاری',
    whDateColumn: 'ڕێکەوتی کۆگا',
    warehousePassedLabel: 'ڕێکەوتی کۆگا تێپەڕیوە',
    warehouseDateChangedSuccessfully: 'ڕێکەوتی کۆگا گۆڕدرا',
    orderPriceLabel: 'نرخی داواکاری',
    willPayOption: 'پارە دەدات',
    loanOption: 'قەرز',
    allOrdersApprovedAndPurchased: 'هەموو داواکارییە هەڵبژێردراوەکان پەسەندکراون و کڕدران.',
    goToCustomerCreditLink: 'بڕۆ بۆ کرێدیتی کڕیار',
    addShipOnlyTitle: 'زیادکردنی تەنها گەیاندن'
  },
  activityLog: {
    accountTypeLabel: 'جۆری هەژمار',
    allAccountsOption: 'هەموو هەژمارەکان',
    allPlatformsOption: 'هەموو پلاتفۆرمەکان',
    adminWebOption: 'بەڕێوەبەر (وێب)',
    mobileIosOption: 'مۆبایل (iOS)',
    mobileAndroidOption: 'مۆبایل (Android)',
    accountNameLabel: 'هەژمار (ناو)',
    searchStaffOrCustomerPlaceholder: 'گەڕان بۆ ناوی ستاف یان کڕیار',
    eventLabel: 'ڕووداو',
    eventPlaceholder: 'بۆ نموونە: post, approved, login',
    subjectTypeLabel: 'جۆری بابەت',
    subjectTypePlaceholder: 'بۆ نموونە: Order, Invoice',
    routeOrDescriptionPlaceholder: 'ڕێڕەو یان وەسف',
    showingHistoryForPrefix: 'نیشاندانی مێژوو بۆ',
    accountColumn: 'هەژمار',
    guestLabel: 'میوان'
  },
  customerDeviceIcon: {
    orderedViaMobileApp: 'داواکراوە لە ڕێگەی ئەپی مۆبایلەوە',
    orderedViaWeb: 'داواکراوە لە ڕێگەی وێبەوە',
    addedByAdminStaff: 'زیادکراوە لەلایەن بەڕێوەبەر/ستاف',
    unknownSourceLegacyOrder: 'سەرچاوەی نەزانراو (داواکاری کۆن)'
  },
  editBank: {
    title: 'دەستکاریکردنی بانک',
    loadingBanks: 'بارکردنی بانکەکان...',
    selectBankLabel: 'بانک هەڵبژێرە'
  },
  editEntityField: {
    editTypeTitle: 'دەستکاریکردنی جۆر',
    typeUpdatedSuccessfully: 'جۆر بە سەرکەوتوویی نوێکرایەوە',
    editSizeTitle: 'دەستکاریکردنی قەبارە',
    sizeUpdatedSuccessfully: 'قەبارە بە سەرکەوتوویی نوێکرایەوە',
    editColorTitle: 'دەستکاریکردنی ڕەنگ',
    colorUpdatedSuccessfully: 'ڕەنگ بە سەرکەوتوویی نوێکرایەوە'
  },
  editPriceForCountry: {
    priceUpdatedSuccessfully: 'نرخ بە سەرکەوتوویی نوێکرایەوە',
    pricePerWeightTurkeyLabel: 'نرخی کێش بۆ تورکیا',
    pricePerWeightUsaLabel: 'نرخی کێش بۆ ئەمریکا'
  },
  editQuantity: {
    title: 'دەستکاریکردنی بڕ',
    updatedSuccessfully: 'بڕ بە سەرکەوتوویی نوێکرایەوە'
  },
  editQuantityCharge: {
    usaOtherLabel: 'باجی بڕی دیکە - ئەمریکا',
    usaOtherUpdatedSuccessfully: 'باجی بڕی دیکە - ئەمریکا بە سەرکەوتوویی نوێکرایەوە',
    turkeyOtherLabel: 'باجی بڕی دیکە - تورکیا',
    turkeyOtherUpdatedSuccessfully: 'باجی بڕی دیکە - تورکیا بە سەرکەوتوویی نوێکرایەوە',
    usaBaseLabel: 'باجی بڕی بنەڕەتی - ئەمریکا',
    usaBaseUpdatedSuccessfully: 'باجی بڕی بنەڕەتی - ئەمریکا بە سەرکەوتوویی نوێکرایەوە',
    turkeyBaseLabel: 'باجی بڕی بنەڕەتی - تورکیا',
    turkeyBaseUpdatedSuccessfully: 'باجی بڕی بنەڕەتی - تورکیا بە سەرکەوتوویی نوێکرایەوە'
  },
  giveToCustomer: {
    title: 'دەستکاریکردنی ڕێژە',
    givenSuccessfully: 'کوپۆن بە سەرکەوتوویی درا بە کڕیار',
    giveButton: 'دان'
  },
  editProductUrl: {
    title: 'دەستکاریکردنی بەستەری بەرهەم',
    updatedSuccessfully: 'بەستەری بەرهەم بە سەرکەوتوویی نوێکرایەوە'
  },
  addRefundNumber: {
    title: 'زیادکردنی ژمارەی گەڕاندنەوە',
    addedSuccessfully: 'ژمارەی گەڕاندنەوە بە سەرکەوتوویی زیادکرا'
  },
  mobileDatatable: {
    infoAndDateColumn: 'زانیاری و ڕێکەوت',
    staffDetailColumn: 'وردەکاری ستاف',
    infoAndStatusColumn: 'زانیاری و دۆخ',
    customerDetailColumn: 'وردەکاری کڕیار',
    invoiceDetailColumn: 'وردەکاری پسوڵە',
    actionAndDateColumn: 'کردار و ڕێکەوت',
    couponDetailColumn: 'وردەکاری کوپۆن',
    statusAndDatesColumn: 'دۆخ و ڕێکەوتەکان',
    customerAndDateColumn: 'کڕیار و ڕێکەوت',
    staffAndCustomerColumn: 'ستاف و کڕیار',
    statusAndDateColumn: 'دۆخ و ڕێکەوت',
    rateDetailColumn: 'وردەکاری نرخ',
    dateAndActionsColumn: 'ڕێکەوت و کردارەکان'
  },
  shippingPrices: {
    title: 'نرخی گەیاندن (تورکیا)',
    updatedSuccessfully: 'نرخی گەیاندن بە سەرکەوتوویی نوێکرایەوە',
    pleaseUpdateAnythingError: 'تکایە شتێک نوێ بکەرەوە',
    addTypeButton: 'زیادکردنی جۆر'
  },
  phoneInput: {
    searchCountryLabel: 'گەڕان بۆ وڵات',
    noMatches: 'هیچ ئەنجامێک نییە',
    phoneRequiredError: 'ژمارەی تەلەفۆن پێویستە',
    phoneNotCorrectError: 'ژمارەی تەلەفۆن دروست نییە'
  },
  orderImage: {
    title: 'وێنەی داواکاری',
    openCameraButton: 'کردنەوەی کامێرا',
    closeCameraButton: 'داخستنی کامێرا',
    flipCameraButton: 'گۆڕینی کامێرا',
    downloadLink: 'داگرتن',
    cameraNotSupportedError: 'لەوانەیە وێبگەڕ پشتگیری نەکات یان هەڵەیەک ڕوویداوە.',
    imageSavedMessage: 'وێنە پاشکەوتکرا'
  },
  logs: {
    cashBackInvoiceTitle: 'پسوڵەی گەڕاندنەوەی پارە',
    exRateLabel: 'نرخی ئاڵوگۆڕ',
    failedToMergeSelectedInvoices: 'تێکەڵکردنی پسوڵە هەڵبژێردراوەکان سەرنەکەوت.',
    receiptLabel: 'پسوڵە',
    creditInvoiceNumber: 'ژمارەی پسوڵەی کرێدیت',
    customerAddress: 'ناونیشانی کڕیار',
    customerTel: 'تەلەفۆنی کڕیار',
    oldAmount: 'بڕی کۆن',
    newAmount: 'بڕی نوێ',
    totalIqdLabel: 'کۆی گشتی بە دینار',
    refundInvoiceTitle: 'پسوڵەی گەڕاندنەوە',
    shoppingOnlineInvoiceTitle: 'پسوڵەی کڕینی ئۆنلاین',
    orderNumberColon: 'ژمارەی داواکاری:',
    itemColumn: 'کاڵا',
    refundReasonPrefix: 'گەڕاندنەوە —',
    deliveryPriceColon: 'نرخی گەیاندن:',
    deliveryColon: 'گەیاندن:',
    shipZoneFeeColon: 'کرێی ShipZone:',
    deliveryIraqiPriceColon: 'نرخی گەیاندن بە دینار:',
    phoneColon: 'تەلەفۆن:',
    emailColon: 'ئیمەیل:',
    signatureLabel: 'واژۆ: _______________________________',
    orderNoColumn: 'ژمارەی داواکاری',
    remainColumn: 'ماوە',
    subTotalLabel: 'کۆی گشتی بەشەکی:',
    totalPaidLabel: 'کۆی پارەدراو:',
    totalRemainingLabel: 'کۆی ماوە:',
    totalReceivedLabel: 'کۆی وەرگیراو:',
    totalRemainLabel: 'کۆی ماوە:'
  },
  whatsappTemplate: {
    sendWhatsappMessageLabel: 'ناردنی نامەی واتسئاپ',
    englishMessageLabel: 'نامە بە ئینگلیزی',
    arabicMessageLabel: 'نامە بە عەرەبی',
    kurdishMessageLabel: 'نامە بە کوردی',
    saveAsDefaultTemplateButton: 'پاشەکەوتکردن وەک قاڵبی بنەڕەتی',
    deliverToBranchTitle: 'گەیاندن بۆ لق',
    sendAllToBranchTitle: 'ناردنی هەموو بۆ لق',
    templateSavedSuccessfully: 'قاڵب بە سەرکەوتوویی پاشەکەوتکرا',
    failedToSaveTemplate: 'پاشەکەوتکردنی قاڵب سەرنەکەوت'
  },
  orderLog: {
    yourStaffLabel: 'کارمەندەکەت',
    yourCustomerLabel: 'کڕیارەکەت',
    requestedVerb: 'داوای کرد',
    theOrderConnector: 'داواکارییەکە',
    deliveredTheOrderLabel: 'داواکارییەکەی گەیاند',
    toConnector: 'بۆ',
    shippedVerb: 'ناردی',
    processedVerb: 'پرۆسەی کرد',
    canceledVerb: 'هەڵیوەشاندەوە',
    approvedVerb: 'پەسەندی کرد',
    refundedVerb: 'گەڕاندییەوە',
    purchasedVerb: 'کڕی',
    sentToBranchVerb: 'ناردی بۆ لق',
    atConnector: 'لە'
  }
}



// WEBPACK FOOTER //
// ./src/lang/ku.js